(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode(`.platform-selection-controls[data-v-073e9c39]{display:flex;align-items:center;justify-content:space-between;background:#fff;padding:16px 24px;margin:0 0 16px;border-radius:8px;box-shadow:0 1px 3px #0000000d;flex-wrap:wrap;gap:12px}.control-left[data-v-073e9c39]{font-weight:500;font-size:16px;color:#333}.selected-count[data-v-073e9c39]{font-weight:400;font-size:14px;color:#333;margin-left:8px}.count-number[data-v-073e9c39]{color:var(--primary-color);font-weight:700}.control-center[data-v-073e9c39]{flex:1;text-align:center}.control-right[data-v-073e9c39]{font-size:14px}.platform-tags-selection[data-v-073e9c39]{background:#fff;padding:16px 24px;margin:0 0 16px;border-radius:8px;box-shadow:0 1px 3px #0000000d}.tags-title[data-v-073e9c39]{font-weight:500;font-size:14px;color:#333;margin-bottom:12px}.tags-container[data-v-073e9c39]{display:flex;flex-wrap:wrap;gap:8px}.platform-tag[data-v-073e9c39]{cursor:pointer;font-size:12px;padding:2px 10px;transition:all .3s ease}.platform-tag[data-v-073e9c39]:hover{box-shadow:0 2px 8px #00000026}.tag-outline[data-v-073e9c39]{background-color:transparent!important;border:1px solid var(--danger-color)!important;color:var(--danger-color)!important}.tag-selected[data-v-073e9c39]{background-color:var(--primary-color)!important;color:#fff!important}.platforms-card[data-v-073e9c39]{margin-bottom:40px;box-shadow:0 8px 32px #00000014;border-radius:16px;background:#fff;transition:all .3s ease}.platforms-card[data-v-073e9c39]:hover{box-shadow:0 12px 48px #0000001f}.platforms-list[data-v-073e9c39]{padding:20px 0}html.dark .platforms-list[data-v-073e9c39]{background-color:#1f1f1f!important;color:#fff!important}.platforms-checkbox-group[data-v-073e9c39]{width:100%}.platform-item[data-v-073e9c39]{display:flex;flex-direction:column}.platform-name[data-v-073e9c39]{font-weight:500;display:flex;align-items:center;gap:8px}.platform-description[data-v-073e9c39]{font-size:12px;color:#666;margin-top:4px}.platform-favicon[data-v-073e9c39]{width:16px;height:16px;margin-right:6px;vertical-align:middle;border-radius:2px;background-image:url("data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><text x='0.5em' y='1em' font-size='12'>🔍</text></svg>");background-size:cover;background-position:center}.category-display[data-v-073e9c39]{padding:20px 0}.category-section[data-v-073e9c39]{margin-bottom:32px}.category-header[data-v-073e9c39]{display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;padding:0 4px}.category-title[data-v-073e9c39]{font-size:1.2em;font-weight:600;color:var(--primary-color);display:flex;align-items:center;gap:8px;margin:0}.category-select-all[data-v-073e9c39]{display:flex;align-items:center}.category-select-all[data-v-073e9c39] .ant-checkbox{font-size:14px;color:#666}.grid-display[data-v-073e9c39]{padding:20px 0}.grid-checkbox-group[data-v-073e9c39]{width:100%}.grid-item[data-v-073e9c39]{background:#fff;border:2px solid #e8e8e8;border-radius:8px;padding:20px;cursor:pointer;transition:all .2s;text-align:center;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}.grid-item[data-v-073e9c39]:hover{border-color:var(--primary-color);box-shadow:0 2px 8px #f5222d33}.grid-item.selected[data-v-073e9c39]{border-color:var(--primary-color);background:#fff1f0}.grid-item-icon[data-v-073e9c39]{font-size:32px;margin-bottom:12px}.grid-item-name[data-v-073e9c39]{font-weight:500;margin-bottom:4px;font-size:14px;display:flex;align-items:center;gap:8px}.grid-item-category[data-v-073e9c39]{font-size:12px;color:#666}.list-display[data-v-073e9c39]{padding:20px 0}.list-checkbox-group[data-v-073e9c39]{width:100%}.list-wrapper[data-v-073e9c39]{display:block;width:100%}.list-platform-wrapper[data-v-073e9c39]{display:block;width:100%;margin-bottom:12px}.list-item[data-v-073e9c39]{background:#fff;border:1px solid #e8e8e8;border-radius:4px;padding:16px;cursor:pointer;transition:all .2s;display:flex;align-items:flex-start;width:100%;box-sizing:border-box;float:none;clear:both;box-shadow:0 1px 3px #0000000d}.list-item[data-v-073e9c39]:hover{background:#fafafa;box-shadow:0 2px 6px #0000001a}.list-item.selected[data-v-073e9c39]{background:#fff1f0;border-color:#ffccc7}.list-item-checkbox[data-v-073e9c39]{margin-right:16px;margin-top:2px;flex-shrink:0}.list-item-icon[data-v-073e9c39]{font-size:24px;margin-right:16px;flex-shrink:0}.list-item-main[data-v-073e9c39]{display:flex;flex:1;align-items:flex-start;gap:20px}.list-item-info[data-v-073e9c39]{display:block;flex-shrink:0}.list-item-name[data-v-073e9c39]{font-weight:600;display:block;font-size:14px;margin-bottom:4px}.list-item-category[data-v-073e9c39]{font-size:12px;color:#666;display:block}.list-item-description[data-v-073e9c39]{font-size:12px;color:#999;display:block;flex:1;line-height:1.5}.tags-container[data-v-073e9c39]{flex-wrap:wrap;gap:8px;overflow-x:hidden}@media(max-width:768px){.search-container[data-v-073e9c39]{padding:0 10px}.platform-selection-controls[data-v-073e9c39]{flex-direction:column;align-items:stretch}.control-center[data-v-073e9c39]{order:3;width:100%;text-align:left;margin:10px 0}[data-v-073e9c39] .ant-radio-group{display:flex;flex-wrap:wrap}[data-v-073e9c39] .ant-radio-button-wrapper{margin-bottom:8px}.grid-item[data-v-073e9c39]{padding:12px}.grid-item-icon[data-v-073e9c39]{font-size:24px}.grid-item-name[data-v-073e9c39]{font-size:12px}.list-item[data-v-073e9c39]{padding:12px;flex-direction:column;align-items:flex-start;gap:8px}}html.dark .platform-selection-controls[data-v-073e9c39]{background-color:#1f1f1f!important;color:#fff!important;box-shadow:0 4px 12px #00000026!important}html.dark .control-left[data-v-073e9c39]{color:#ffffffd9!important}html.dark .selected-count[data-v-073e9c39]{color:#ffffffa6!important}html.dark .count-number[data-v-073e9c39]{color:var(--danger-color)!important;font-weight:700}html.dark .platform-tags-selection[data-v-073e9c39]{background-color:#1f1f1f!important;color:#fff!important}html.dark .tags-title[data-v-073e9c39]{color:#ffffffd9!important}html.dark .platform-tag[data-v-073e9c39]{color:#ffffffa6!important;border-color:#fff3!important}html.dark .platform-tag.tag-selected[data-v-073e9c39]{background-color:#f5222d33!important;color:var(--primary-color)!important;border-color:var(--primary-color)!important}html.dark .platform-tag.tag-outline[data-v-073e9c39]{color:#ffffffa6!important;border-color:#fff3!important}html.dark .platform-tag[data-v-073e9c39]:hover{color:var(--primary-color)!important;border-color:var(--primary-color)!important}html.dark .platforms-card[data-v-073e9c39]{background:#1f1f1f!important;color:#fff!important}html.dark .platforms-card[data-v-073e9c39]:hover{box-shadow:0 12px 48px #0000004d!important}[data-v-073e9c39] html.dark .ant-tabs{color:#fff!important}[data-v-073e9c39] html.dark .ant-tabs-tab{color:#ffffffa6!important}[data-v-073e9c39] html.dark .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{color:var(--primary-color)!important}[data-v-073e9c39] html.dark .ant-tabs-content-holder,[data-v-073e9c39] html.dark .ant-tabs-content{background-color:#141414!important}[data-v-073e9c39] html.dark .ant-tabs-tabpane{background-color:#1f1f1f!important;color:#fff!important}html.dark .grid-item[data-v-073e9c39]{background:#1f1f1f!important;border-color:#333!important;color:#ffffffd9!important}html.dark .grid-item[data-v-073e9c39]:hover{border-color:var(--primary-color)!important;box-shadow:0 2px 8px #f5222d33!important}html.dark .grid-item.selected[data-v-073e9c39]{border-color:var(--primary-color)!important;background:#f5222d1a!important}html.dark .grid-item-category[data-v-073e9c39]{color:#ffffffa6!important}html.dark .list-item[data-v-073e9c39]{background:#1f1f1f!important;border-color:#333!important;color:#ffffffd9!important;box-shadow:0 1px 3px #00000026!important}html.dark .list-item[data-v-073e9c39]:hover{background:#ffffff14!important;border-color:var(--primary-color)!important;box-shadow:0 2px 6px #f5222d33!important}html.dark .list-item.selected[data-v-073e9c39]{background:#f5222d1a!important;border-color:var(--primary-color)!important}html.dark .list-item-category[data-v-073e9c39]{color:#ffffffa6!important}html.dark .list-item-description[data-v-073e9c39]{color:#ffffff73!important}html.dark .platform-name[data-v-073e9c39]{color:#ffffffd9!important}html.dark .platform-description[data-v-073e9c39]{color:#ffffff73!important}[data-v-073e9c39] html.dark .ant-radio-group{color:#fff!important}[data-v-073e9c39] html.dark .ant-radio-button-wrapper{background-color:#1f1f1f!important;color:#ffffffa6!important;border-color:#333!important}[data-v-073e9c39] html.dark .ant-radio-button-wrapper-checked{background-color:var(--primary-color)!important;border-color:var(--primary-color)!important;color:#fff!important}[data-v-073e9c39] html.dark .ant-radio-button-wrapper-checked:hover{background-color:var(--danger-color)!important;border-color:var(--danger-color)!important;color:#fff!important}[data-v-073e9c39] html.dark .ant-radio-button-wrapper:hover{color:var(--primary-color)!important;border-color:var(--primary-color)!important}[data-v-073e9c39] .ant-radio-button-wrapper:not(:first-child):before{background-color:#d9d9d9}[data-v-073e9c39] html.dark .ant-radio-button-wrapper:not(:first-child):before{background-color:#333!important}[data-v-073e9c39] html.dark .ant-radio-button-wrapper-checked+.ant-radio-button-wrapper:before{background-color:var(--primary-color)!important}[data-v-073e9c39] html.dark .ant-checkbox-wrapper{color:#fff!important}[data-v-073e9c39] html.dark .ant-checkbox-inner{background-color:#333!important;border-color:#444!important}[data-v-073e9c39] html.dark .ant-checkbox-checked .ant-checkbox-inner{background-color:var(--primary-color)!important;border-color:var(--primary-color)!important}[data-v-073e9c39] html.dark .ant-checkbox:hover .ant-checkbox-inner{border-color:var(--danger-color)!important}[data-v-073e9c39] html.dark .ant-checkbox-disabled .ant-checkbox-inner{background-color:#262626!important;border-color:#444!important}[data-v-073e9c39] html.dark .ant-checkbox-disabled .ant-checkbox-wrapper{color:#ffffff4d!important}.search-icon-dropdown[data-v-b4c81e84]{cursor:pointer;display:flex;align-items:center;justify-content:flex-start;width:100%;height:100%;padding:0;transition:opacity .3s ease}.search-icon-dropdown[data-v-b4c81e84]:hover{opacity:.8}.search-engine-selector[data-v-b4c81e84]{width:100%;display:flex;justify-content:center;align-items:center}.search-engine-option-content[data-v-b4c81e84]{display:flex;justify-content:flex-start;align-items:center;gap:6px}.search-engine-icon[data-v-b4c81e84]{font-size:16px;display:flex;align-items:center;justify-content:center}.search-engine-img[data-v-b4c81e84]{width:16px;height:16px;border-radius:4px;margin-top:-4px;vertical-align:middle}.search-box-container[data-v-b4c81e84]{display:flex;flex-direction:column;align-items:center;justify-content:center}.search-input[data-v-b4c81e84]{width:100%}.search-input .ant-btn-primary[data-v-b4c81e84]{font-weight:700!important}.search-engine-name[data-v-b4c81e84]{margin-left:5px}.seekflow-search-container[data-v-b99aceb4]{font-family:Arial,sans-serif;width:100%}.seekflow-search-header[data-v-b99aceb4]{background-color:#fff;border-bottom:1px solid #ebebeb;padding:20px;max-width:1200px;margin:0 auto;position:relative}.header-content[data-v-b99aceb4]{display:flex;align-items:center;gap:20px}.seekflow-logo[data-v-b99aceb4]{flex-shrink:0}.setting-button-wrapper[data-v-b99aceb4]{margin-left:auto;display:flex;align-items:center;justify-content:center}.setting-button[data-v-b99aceb4]{font-size:14px;display:flex;align-items:center;gap:4px;color:#333;border:1px solid #dfe1e5;border-radius:4px;padding:6px 12px;transition:all .3s ease}.setting-button[data-v-b99aceb4]:hover{color:var(--primary-color);background:#0000000d}.logo-link[data-v-b99aceb4]{display:flex;align-items:center}.search-box-container[data-v-b99aceb4]{flex-grow:1;max-width:800px}.seekflow-search-input[data-v-b99aceb4]{width:100%}.seekflow-search-input[data-v-b99aceb4] .ant-input-wrapper{background-color:#fff;border:1px solid #dfe1e5;border-radius:24px;height:44px;transition:all .2s ease;box-shadow:none}.seekflow-search-input[data-v-b99aceb4] .ant-input-wrapper:hover{box-shadow:0 1px 6px #20212447;border-color:#dfe1e500}.seekflow-search-input[data-v-b99aceb4] .ant-input{border:none;font-size:16px;box-shadow:none;padding:0 8px;height:34px;background:transparent}.seekflow-search-input[data-v-b99aceb4] .ant-input:focus{box-shadow:none}.seekflow-search-input[data-v-b99aceb4] .ant-input-clear-icon{font-size:16px;color:#8c8c8c}.seekflow-search-input[data-v-b99aceb4] .ant-btn{background:transparent;border:none;box-shadow:none;padding:5px;display:flex;align-items:center;justify-content:center}.seekflow-search-input[data-v-b99aceb4] .ant-btn:hover{background:transparent;border:none;box-shadow:none;color:var(--primary-color)}.search-icon[data-v-b99aceb4]{font-size:26px;color:var(--primary-color)}.seekflow-tabs[data-v-b99aceb4]{max-width:1200px;margin:0 auto;padding:12px 16px}.seekflow-tabs-container[data-v-b99aceb4]{width:fit-content}.seekflow-tabs-container[data-v-b99aceb4] .ant-tabs-nav{margin-bottom:0;text-align:left}.seekflow-tabs-container[data-v-b99aceb4] .ant-tabs-tab{padding:12px;margin:0 6px;border-bottom:3px solid transparent;color:#70757a;font-size:15px;transition:all .2s ease}.seekflow-tabs-container[data-v-b99aceb4] .ant-tabs-tab-active{color:var(--primary-color);border-bottom-color:var(--primary-color);font-weight:500}.seekflow-tabs-container[data-v-b99aceb4] .ant-tabs-tab:hover{color:#fa8c16}.seekflow-tabs-container[data-v-b99aceb4] .ant-tabs-tab-btn{display:flex;align-items:center;gap:6px;padding:0}.tab-content[data-v-b99aceb4]{display:flex;align-items:center;gap:6px}.tab-icon[data-v-b99aceb4]{font-size:18px;width:16px;height:16px}.seekflow-tabs-container[data-v-b99aceb4] .ant-tabs-ink-bar{display:none}.seekflow-main-content[data-v-b99aceb4]{display:flex;max-width:1200px;margin:20px auto;gap:40px;padding:0 20px}.search-results-column[data-v-b99aceb4]{flex:1;min-width:0}.search-info[data-v-b99aceb4]{margin-bottom:20px;color:#70757a;font-size:14px}.search-results-list[data-v-b99aceb4]{min-height:500px}.loading-state[data-v-b99aceb4]{display:flex;justify-content:center;align-items:center;height:500px}.loading-content[data-v-b99aceb4]{width:200px;height:200px;border-radius:10px}.loading-state .ant-spin[data-v-b99aceb4]{margin:0;box-shadow:none!important}.loading-state .ant-spin-tip[data-v-b99aceb4]{margin-top:16px;font-size:14px;color:#666;text-shadow:none!important}.loading-state[data-v-b99aceb4] .ant-spin-spinning{box-shadow:none!important;text-shadow:none!important;background:transparent!important}.error-state[data-v-b99aceb4]{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:20px;height:500px}.error-state .ant-btn[data-v-b99aceb4]{margin-top:20px}.empty-state[data-v-b99aceb4]{display:flex;justify-content:center;align-items:center;height:500px}.results-list[data-v-b99aceb4]{display:flex;flex-direction:column;gap:8px}.results-list .result-item[data-v-b99aceb4]{padding:16px 0;margin-bottom:8px;background-color:transparent;border-radius:0;box-shadow:none;transition:none}.results-list .result-item[data-v-b99aceb4]:hover{box-shadow:none}.result-url-container[data-v-b99aceb4]{margin-bottom:4px}.site-info[data-v-b99aceb4]{display:flex;align-items:flex-start;gap:6px;margin-bottom:4px;font-size:14px}.site-favicon[data-v-b99aceb4]{margin-top:2px;border-radius:4px;object-fit:cover}.site-details[data-v-b99aceb4]{display:flex;flex-direction:column;gap:2px}.site-name[data-v-b99aceb4]{color:#333;font-weight:500;font-size:14px}.result-url[data-v-b99aceb4]{font-size:12px;color:#666;text-decoration:none;margin-bottom:4px;word-break:break-all;font-family:Roboto,Arial,sans-serif;display:inline;max-width:500px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.result-title[data-v-b99aceb4]{font-size:18px;color:#4007a2!important;text-decoration:none;font-weight:400;margin-bottom:4px;display:block;line-height:1.3;transition:color .2s ease;font-family:seekflow Sans,Arial,sans-serif}.result-title[data-v-b99aceb4]:hover{color:var(--primary-color)!important;text-decoration:underline}.result-description[data-v-b99aceb4]{font-size:14px;color:#202124;line-height:1.5;margin:8px 0;font-family:Roboto,Arial,sans-serif;word-wrap:break-word}.related-content-column[data-v-b99aceb4]{width:300px;flex-shrink:0}.related-searches[data-v-b99aceb4]{background-color:#f8f9fa;border-radius:8px;padding:16px;margin-bottom:24px;box-shadow:0 1px 2px #0000001a}.related-searches-title[data-v-b99aceb4]{font-size:18px;font-weight:500;margin-bottom:16px;color:#202124;font-family:seekflow Sans,Arial,sans-serif}.related-searches-list[data-v-b99aceb4]{display:grid;grid-template-columns:repeat(2,1fr);gap:12px}.related-search-item[data-v-b99aceb4]{font-size:14px;color:#4007a2;text-decoration:none;padding:8px 12px;display:block;line-height:1.4;border-radius:4px;transition:all .2s ease}.related-search-item[data-v-b99aceb4]:hover{text-decoration:underline;background-color:#0000000a;color:var(--primary-color)}.related-content[data-v-b99aceb4]{background-color:#f8f9fa;border-radius:8px;padding:16px;margin-bottom:24px;box-shadow:0 1px 2px #0000001a}.related-content-title[data-v-b99aceb4]{font-size:18px;font-weight:500;margin-bottom:16px;color:#202124;font-family:seekflow Sans,Arial,sans-serif}.related-content-list[data-v-b99aceb4]{display:flex;flex-direction:column;gap:12px}.related-content-item[data-v-b99aceb4]{display:flex;align-items:center;gap:12px}.related-content-number[data-v-b99aceb4]{font-size:14px;color:#70757a;font-weight:500;min-width:20px;text-align:right}.related-content-link[data-v-b99aceb4]{font-size:14px;color:#4007a2!important;text-decoration:none;flex-grow:1;line-height:1.4;padding:4px 0}.related-content-link[data-v-b99aceb4]:hover{color:var(--primary-color)!important;text-decoration:underline}.pagination-container[data-v-b99aceb4]{display:flex;justify-content:center;margin-top:20px;margin-bottom:40px}[data-v-b99aceb4] .ant-pagination{font-family:arial,sans-serif}[data-v-b99aceb4] .ant-pagination-item{border:1px solid #dfe1e5;border-radius:50%;margin:0 2px}[data-v-b99aceb4] .ant-pagination-item a{color:var(--primary-color);font-size:14px}[data-v-b99aceb4] .ant-pagination-item:hover{border-color:var(--primary-color)}[data-v-b99aceb4] .ant-pagination-item-active{background-color:var(--primary-color);border-color:var(--primary-color)}[data-v-b99aceb4] .ant-pagination-item-active a{color:#fff!important}[data-v-b99aceb4] .ant-pagination-prev{margin-right:10px}[data-v-b99aceb4] .ant-pagination-next{margin-left:10px}[data-v-b99aceb4] .ant-pagination-item-ellipsis,[data-v-b99aceb4] .ant-pagination-item-link-icon,[data-v-b99aceb4] .ant-pagination-item-ellipsis:hover,[data-v-b99aceb4] .ant-pagination-item-link-icon:hover{color:var(--primary-color)!important}[data-v-b99aceb4] button.ant-pagination-item-link,[data-v-b99aceb4] .ant-pagination-prev:hover .ant-pagination-item-link,[data-v-b99aceb4] .ant-pagination-next:hover .ant-pagination-item-link,[data-v-b99aceb4] .ant-pagination-item-container{border:1px solid #dfe1e5!important;border-radius:50%!important;color:var(--primary-color)!important}[data-v-b99aceb4] button.ant-pagination-item-link,[data-v-b99aceb4] .ant-pagination-prev:hover .ant-pagination-item-link,[data-v-b99aceb4] .ant-pagination-next:hover .ant-pagination-item-link,[data-v-b99aceb4] .ant-pagination-item-container{border-color:var(--primary-color);color:var(--primary-color)!important}@media(max-width:1024px){.seekflow-main-content[data-v-b99aceb4]{flex-direction:column}.search-results-column[data-v-b99aceb4]{max-width:100%}.related-content-column[data-v-b99aceb4]{width:100%;margin-top:20px}.related-searches-list[data-v-b99aceb4]{grid-template-columns:repeat(auto-fill,minmax(150px,1fr))}}@media(max-width:992px){.header-content[data-v-b99aceb4]{flex-wrap:wrap}.search-box-container[data-v-b99aceb4]{order:3;flex-basis:100%}.seekflow-logo[data-v-b99aceb4]{order:1}.setting-button-wrapper[data-v-b99aceb4]{order:2}}@media(max-width:768px){.header-content[data-v-b99aceb4]{flex-direction:column;align-items:stretch}.seekflow-search-header[data-v-b99aceb4]{padding:10px}.seekflow-logo[data-v-b99aceb4]{margin-bottom:12px}.search-box-container[data-v-b99aceb4]{max-width:100%;order:initial;flex-basis:initial}.seekflow-main-content[data-v-b99aceb4]{padding:0 10px}.tabs-content[data-v-b99aceb4]{margin-left:0;overflow-x:auto;padding-bottom:8px}.result-title[data-v-b99aceb4]{font-size:16px}.seekflow-tabs-container[data-v-b99aceb4] .ant-tabs-tab{padding:8px 16px;font-size:14px}.related-searches-list[data-v-b99aceb4]{grid-template-columns:repeat(auto-fill,minmax(120px,1fr))}}@media(max-width:576px){.seekflow-tabs[data-v-b99aceb4]{overflow-x:auto}.seekflow-tabs-container[data-v-b99aceb4]{min-width:500px}.site-details[data-v-b99aceb4]{max-width:calc(100% - 46px)}.result-url[data-v-b99aceb4]{max-width:100%}}html.dark .seekflow-search-header[data-v-b99aceb4]{background-color:#141414;border-bottom-color:#333}html.dark .seekflow-search-input[data-v-b99aceb4] .ant-input-wrapper{background-color:#303134;border-color:#5f6368}html.dark .seekflow-search-input[data-v-b99aceb4] .ant-input-wrapper:hover{background-color:#303134;border-color:#5f6368;box-shadow:0 1px 6px #0000007a}html.dark .seekflow-search-input[data-v-b99aceb4] .ant-input,html.dark .seekflow-search-input[data-v-b99aceb4] .ant-btn{color:#e8eaed}html.dark .seekflow-search-input[data-v-b99aceb4] .ant-input-clear-icon{color:#999}html.dark .setting-button[data-v-b99aceb4]{border-color:#5f6368;color:#e8eaed}html.dark .seekflow-tabs-container[data-v-b99aceb4] .ant-tabs-tab{color:#9aa0a6}html.dark .seekflow-tabs-container[data-v-b99aceb4] .ant-tabs-tab:hover{color:#e8eaed}html.dark .seekflow-tabs-container[data-v-b99aceb4] .ant-tabs-tab-active{color:var(--primary-color)}html.dark .loading-state[data-v-b99aceb4] .ant-spin-spinning{background:#141414!important}html.dark .loading-state[data-v-b99aceb4] .ant-spin-text{text-shadow:none!important}html.dark .search-info p[data-v-b99aceb4]{color:#9aa0a6}html.dark .search-results-list[data-v-b99aceb4]{background:transparent;box-shadow:none}html.dark .result-title[data-v-b99aceb4]{color:#82c7ff!important}html.dark .site-name[data-v-b99aceb4]{color:#999}html.dark .result-url[data-v-b99aceb4]{color:#666}html.dark .result-description[data-v-b99aceb4]{color:#e8eaed}html.dark .related-searches[data-v-b99aceb4],html.dark .related-content[data-v-b99aceb4]{background-color:#202124;box-shadow:0 1px 2px #ffffff1a}html.dark .related-searches-title[data-v-b99aceb4],html.dark .related-content-title[data-v-b99aceb4]{color:#e8eaed}html.dark .related-search-item[data-v-b99aceb4]{color:#82c7ff}html.dark .related-search-item[data-v-b99aceb4]:hover{background-color:#ffffff0a;color:var(--primary-color)}html.dark .related-content-number[data-v-b99aceb4]{color:#9aa0a6}html.dark .related-content-link[data-v-b99aceb4]{color:#e8eaed!important}html.dark[data-v-b99aceb4] .ant-pagination-item{border-color:#333}html.dark[data-v-b99aceb4] .ant-pagination-item a{color:#fff}html.dark[data-v-b99aceb4] .ant-pagination-item:hover{border-color:#fff!important;color:#fff!important}html.dark[data-v-b99aceb4] .ant-pagination-item-active{background-color:var(--primary-color);border-color:var(--primary-color)}html.dark[data-v-b99aceb4] button.ant-pagination-item-link,html.dark[data-v-b99aceb4] .ant-pagination-prev .ant-pagination-item-link,html.dark[data-v-b99aceb4] .ant-pagination-next .ant-pagination-item-link,html.dark[data-v-b99aceb4] .ant-pagination-item-container{border-color:#dfe1e5!important;color:#fff}html.dark[data-v-b99aceb4] button.ant-pagination-item-link,html.dark[data-v-b99aceb4] .ant-pagination-prev:hover .ant-pagination-item-link,html.dark[data-v-b99aceb4] .ant-pagination-next:hover .ant-pagination-item-link,html.dark[data-v-b99aceb4] .ant-pagination-item-container:hover{border-color:var(--primary-color)!important;color:#fff}.setting-container[data-v-3445f4c5]{background:#fff;border-radius:8px;width:100%;max-width:100%}.setting-title[data-v-3445f4c5]{margin:0 0 20px;font-size:20px;font-weight:600;color:#333}.setting-tabs[data-v-3445f4c5]{margin-bottom:16px}[data-v-3445f4c5] .ant-tabs-nav{margin-bottom:0}[data-v-3445f4c5] .ant-tabs-content{margin-top:16px}[data-v-3445f4c5] .ant-tabs-tab{font-size:14px;font-weight:500;color:#666;padding:8px 16px;margin-right:16px}[data-v-3445f4c5] .ant-tabs-tab-active .ant-tabs-tab-btn{color:var(--primary-color);font-weight:600}[data-v-3445f4c5] .ant-tabs-ink-bar{background-color:var(--primary-color);height:2px}[data-v-3445f4c5] .ant-tabs-content{padding:0}.setting-content[data-v-3445f4c5]{display:flex;flex-direction:column;gap:24px;padding:0 20px}.setting-section[data-v-3445f4c5]{display:flex;flex-direction:column;gap:16px}.section-title[data-v-3445f4c5]{margin:0;font-size:16px;font-weight:500;color:#666;border-bottom:1px solid #eee;padding-bottom:8px}.setting-item[data-v-3445f4c5]{display:flex;align-items:flex-start;justify-content:space-between;padding:8px 0;max-width:100%}[data-v-3445f4c5] .ant-collapse-content-box{padding:16px 20px!important}.setting-item[data-v-3445f4c5]:has(>label.setting-label:only-child){justify-content:flex-start;padding-right:20px}.setting-item label.setting-label[data-v-3445f4c5]{flex-shrink:1;min-width:80px;max-width:100%;word-wrap:break-word;white-space:normal;line-height:1.5}.setting-item>span[data-v-3445f4c5],.setting-item>a[data-v-3445f4c5],.setting-item>div[data-v-3445f4c5]{min-width:0}.setting-label[data-v-3445f4c5]{font-size:14px;color:#333}.setting-item[data-v-3445f4c5]:has(>label.setting-label:only-child){justify-content:flex-start}.theme-options[data-v-3445f4c5]{display:flex;gap:24px}.theme-option[data-v-3445f4c5]{display:flex;align-items:center;gap:8px;font-size:14px;cursor:pointer}.theme-option input[type=radio][data-v-3445f4c5]{appearance:none;-webkit-appearance:none;-moz-appearance:none;width:16px;height:16px;border:2px solid #ddd;border-radius:50%;outline:none;cursor:pointer;transition:all .3s ease;position:relative}.theme-option input[type=radio][data-v-3445f4c5]:checked{border-color:var(--primary-color);background-color:var(--primary-color)}.theme-option input[type=radio][data-v-3445f4c5]:checked:after{content:"";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:6px;height:6px;border-radius:50%;background-color:#fff}[data-v-3445f4c5] .ant-switch-checked{background-color:var(--primary-color)}[data-v-3445f4c5] .ant-radio-button-wrapper-checked{color:#fff;background:var(--primary-color);border-color:var(--primary-color)}[data-v-3445f4c5] .ant-radio-button-wrapper-checked:first-child{border-radius:4px 0 0 4px}[data-v-3445f4c5] .ant-radio-button-wrapper-checked:last-child{border-radius:0 4px 4px 0}[data-v-3445f4c5] .ant-radio-button-wrapper-checked:not(:last-child){border-right-color:var(--primary-color)}[data-v-3445f4c5] .ant-tabs-tab{font-size:14px;font-weight:500;color:#666;padding:8px 5px;margin-right:0}.account-info[data-v-3445f4c5]{display:flex;flex-direction:column;gap:16px;width:100%}.account-info-header[data-v-3445f4c5]{display:flex;align-items:center;gap:16px}.account-info-footer[data-v-3445f4c5]{display:flex;justify-content:flex-end}.account-details[data-v-3445f4c5]{flex:1}.prompt-text[data-v-3445f4c5]{font-size:14px;color:#666}.backup-actions[data-v-3445f4c5],.feedback-actions[data-v-3445f4c5]{display:flex;gap:12px}.version-info[data-v-3445f4c5],.developer-info[data-v-3445f4c5]{font-size:14px;color:#333}.contact-info[data-v-3445f4c5]{font-size:14px;color:#8b4513!important;white-space:normal;word-break:break-all;overflow-wrap:break-word;display:inline-block;max-width:100%;text-decoration:none!important}.contact-info[data-v-3445f4c5]:hover{color:sienna!important;text-decoration:underline!important}.about-setting-item[data-v-3445f4c5]{justify-content:flex-start!important;gap:16px!important}.setting-collapse .setting-item a.contact-info[data-v-3445f4c5]{color:#8b4513!important;text-decoration:none!important}.setting-collapse .setting-item a.contact-info[data-v-3445f4c5]:hover{color:sienna!important;text-decoration:underline!important}html.dark .contact-info[data-v-3445f4c5]{color:peru!important}html.dark .contact-info[data-v-3445f4c5]:hover{color:#deb887!important}html.dark .setting-collapse .setting-item a.contact-info[data-v-3445f4c5]{color:peru!important}html.dark .setting-collapse .setting-item a.contact-info[data-v-3445f4c5]:hover{color:#deb887!important}.plugin-icon[data-v-3445f4c5]{display:flex;align-items:center;justify-content:center;width:40px;height:40px;margin-right:12px;flex-shrink:0}.plugin-icon-image[data-v-3445f4c5]{width:100%;height:100%;display:flex;align-items:center;justify-content:center;overflow:hidden;border-radius:4px}.plugin-icon-image img[data-v-3445f4c5]{width:100%;height:100%;object-fit:contain}.plugin-icon-text[data-v-3445f4c5]{width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:24px;line-height:1}.plugin-card-content[data-v-3445f4c5]{display:flex;flex-direction:column;gap:12px;padding:8px 0}.plugin-header[data-v-3445f4c5]{display:flex;align-items:center;gap:12px;margin-bottom:8px;flex-wrap:wrap}.plugin-meta[data-v-3445f4c5]{flex:1;min-width:0;min-width:100px}.plugin-card[data-v-3445f4c5]{border-bottom:1px solid #f0f0f0;margin-bottom:0;box-shadow:none!important;border-radius:0!important}.plugin-card[data-v-3445f4c5] .ant-card-body{padding:10px!important;margin:0!important}.plugin-list>.plugin-card[data-v-3445f4c5]:first-child{border-top:1px solid #f0f0f0}html.dark .plugin-card[data-v-3445f4c5]{border-bottom:1px solid #333}html.dark .plugin-list>.plugin-card[data-v-3445f4c5]:first-child{border-top:1px solid #333}.plugin-list>.plugin-card[data-v-3445f4c5]:last-child{margin-bottom:16px}html.dark .plugin-list>.plugin-card[data-v-3445f4c5]:last-child{border-bottom:1px solid #333}.plugin-actions[data-v-3445f4c5]{display:flex;flex-direction:row;gap:8px;margin-top:8px;flex-wrap:wrap;align-items:center;justify-content:flex-end}.plugin-action-btn[data-v-3445f4c5]{white-space:nowrap;flex-shrink:0}@media(max-width:600px){.plugin-actions[data-v-3445f4c5]{flex-direction:column;align-items:flex-start}.plugin-action-btn[data-v-3445f4c5]{width:auto;min-width:100px}}.platform-setting-item[data-v-3445f4c5]{padding:12px 0;transition:all .3s ease;cursor:move;-webkit-user-select:none;user-select:none}.platform-setting-item[data-v-3445f4c5]:hover{background-color:#f5f5f5}.platform-setting-item.dragging[data-v-3445f4c5]{opacity:.5;background-color:#e6f7ff;border-left:3px solid #1890ff}.platform-setting-content[data-v-3445f4c5]{display:flex;align-items:center;justify-content:space-between;width:100%}.platform-name[data-v-3445f4c5]{font-size:14px;color:#333;display:flex;align-items:center;gap:8px}.drag-icon[data-v-3445f4c5]{cursor:grab;color:#999;font-size:16px;transition:all .3s ease}.drag-icon[data-v-3445f4c5]:hover{color:#1890ff;transform:scale(1.1)}.platform-setting-item:active .drag-icon[data-v-3445f4c5]{cursor:grabbing}.platform-controls[data-v-3445f4c5]{display:flex;align-items:center;gap:16px}.setting-tabs[data-v-3445f4c5] .ant-tabs-tab,html.dark .setting-tabs[data-v-3445f4c5] .ant-tabs-tab{margin:0 10px!important}.plugin-actions[data-v-3445f4c5]{display:flex;gap:12px;margin-bottom:16px}.plugin-list[data-v-3445f4c5]{display:flex;flex-direction:column;gap:16px}.plugin-card[data-v-3445f4c5]{transition:all .3s ease}.plugin-card[data-v-3445f4c5]:hover{box-shadow:0 4px 12px #00000026}.plugin-card-content[data-v-3445f4c5]{display:flex;justify-content:space-between;align-items:flex-start;gap:16px}.plugin-info[data-v-3445f4c5]{flex:1;min-width:0}.plugin-header[data-v-3445f4c5]{display:flex;align-items:center;gap:12px;margin-bottom:8px}.plugin-icon[data-v-3445f4c5]{width:40px;height:40px;border-radius:8px;overflow:hidden}.plugin-icon img[data-v-3445f4c5]{width:100%;height:100%;object-fit:cover}.plugin-meta[data-v-3445f4c5]{flex:1;min-width:0}.plugin-name[data-v-3445f4c5]{font-size:16px;font-weight:500;margin-bottom:2px}.plugin-version[data-v-3445f4c5]{font-size:12px;color:#666}.plugin-status[data-v-3445f4c5]{display:flex;align-items:center}.plugin-description[data-v-3445f4c5]{font-size:14px;color:#333;margin-bottom:8px;line-height:1.5;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.plugin-author[data-v-3445f4c5]{font-size:12px;color:#666}.plugin-controls[data-v-3445f4c5]{display:flex;align-items:center}.empty-plugins[data-v-3445f4c5]{text-align:center;padding:40px 0;color:#999;font-size:14px}.install-plugin-modal[data-v-3445f4c5]{display:flex;flex-direction:column;gap:16px}.install-tips[data-v-3445f4c5]{font-size:12px;color:#666;background-color:#f5f5f5;padding:8px 12px;border-radius:4px;line-height:1.5}html.dark .plugin-card[data-v-3445f4c5]{background-color:#1f1f1f}html.dark .plugin-name[data-v-3445f4c5]{color:#fff}html.dark .plugin-description[data-v-3445f4c5]{color:#ffffffd9}html.dark .plugin-author[data-v-3445f4c5],html.dark .empty-plugins[data-v-3445f4c5]{color:#ffffffa6}html.dark .install-tips[data-v-3445f4c5]{background-color:#262626;color:#ffffffa6}html.dark .ant-tabs-tabpane[data-v-3445f4c5]{background-color:#141414!important;color:#fff!important}.home-container[data-v-81445cda]{min-height:100vh}.home-layout[data-v-81445cda]{min-height:100vh;overflow-x:hidden;width:100%;max-width:100vw}.hero-header[data-v-81445cda]{background:var(--primary-gradient-full);padding:60px 0;text-align:center;color:#fff;box-shadow:0 4px 20px #f5222d33;position:relative}.hero-content[data-v-81445cda]{max-width:800px;margin:0 auto}.search-content[data-v-81445cda]{padding:40px 0;background:#f8fafc}html.dark .search-content[data-v-81445cda]{background:#141414}.search-container[data-v-81445cda]{max-width:1200px;margin:0 auto;padding:0 20px}.setting-button-wrapper[data-v-81445cda]{position:absolute;top:50%;transform:translateY(-50%);right:20px;z-index:10}.setting-button[data-v-81445cda]{font-size:14px;display:flex;align-items:center;gap:4px;color:#fff;transition:all .3s ease}.setting-button[data-v-81445cda]:hover{color:#fff;background:#fff3}.language-button-wrapper[data-v-81445cda]{position:absolute;top:50%;transform:translateY(-50%);left:20px;z-index:10}.language-button[data-v-81445cda]{font-size:14px;display:flex;align-items:center;justify-content:center;gap:6px;color:#fff;transition:all .3s ease;line-height:1}.language-icon[data-v-81445cda]{display:inline-block;transform:translateY(2px)}.language-button[data-v-81445cda]:hover{color:#fff;background:#fff3}:root:not(.dark) .language-button[data-v-81445cda],:root:not(.dark) .setting-button[data-v-81445cda]{border:1px solid rgba(255,255,255,.3);background:#ffffff1a;-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);border-radius:4px}:root:not(.dark) .language-button[data-v-81445cda]:hover,:root:not(.dark) .setting-button[data-v-81445cda]:hover{border:1px solid rgba(255,255,255,.5);background:#fff3}.language-button-wrapper[data-v-81445cda]{position:relative}.language-button-wrapper[data-v-81445cda] .ant-dropdown-content{background:#fffffff2!important;-webkit-backdrop-filter:blur(10px)!important;backdrop-filter:blur(10px)!important;border-radius:8px!important;border:1px solid rgba(0,0,0,.1)!important;box-shadow:0 4px 12px #00000026!important}.language-button-wrapper[data-v-81445cda] .ant-dropdown-menu{background:transparent!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important;border:none!important}.language-button-wrapper[data-v-81445cda] .ant-dropdown-menu-item{color:#333!important;transition:all .3s ease!important}.language-button-wrapper[data-v-81445cda] .ant-dropdown-menu-item:hover{background:#f5222d1a!important;color:var(--primary-color)!important}html.dark .language-button-wrapper[data-v-81445cda] .ant-dropdown-content,html.dark .language-button-wrapper[data-v-81445cda] .ant-dropdown-menu-submenu .ant-dropdown-menu{background:#1f1f1ff2!important;-webkit-backdrop-filter:blur(10px)!important;backdrop-filter:blur(10px)!important;border:1px solid rgba(255,255,255,.1)!important;box-shadow:0 4px 12px #0000004d!important}html.dark .language-button-wrapper[data-v-81445cda] .ant-dropdown-menu-item{color:#ffffffd9!important}html.dark .language-button-wrapper[data-v-81445cda] .ant-dropdown-menu-item:hover{background:#f5222d33!important;color:var(--danger-color)!important}html.dark .ant-dropdown-menu,html.dark .ant-dropdown-menu *,html.dark .ant-menu-item,html.dark .ant-menu-item a,html.dark .ant-menu-item a span,html.dark .ant-menu-item span,html.dark .ant-menu-item .ant-menu-item-content,html.dark .ant-menu-item .ant-menu-item-content span{color:#fff!important}html.dark .ant-dropdown-menu,html.dark .ant-menu-item .ant-menu-item-content{color:#fff!important;background:#1f1f1ff2!important;-webkit-backdrop-filter:blur(10px)!important;backdrop-filter:blur(10px)!important;border:1px solid rgba(255,255,255,.1)!important;box-shadow:0 4px 12px #0000004d!important}html.dark .language-dropdown .ant-dropdown-menu-item:hover{background:#f5222d59!important;color:#fff!important}html.dark .language-button-wrapper[data-v-81445cda] .ant-dropdown .ant-dropdown-menu,html.dark .language-button-wrapper[data-v-81445cda] .ant-dropdown-menu-submenu .ant-dropdown-menu{background-color:#1f1f1ff2!important;-webkit-backdrop-filter:blur(10px)!important;backdrop-filter:blur(10px)!important;border:1px solid rgba(255,255,255,.1)!important;border-radius:8px!important}.language-button-wrapper[data-v-81445cda] .ant-dropdown .ant-dropdown-menu,.language-button-wrapper[data-v-81445cda] .ant-dropdown-menu-submenu .ant-dropdown-menu{background-color:#fffffff2!important;-webkit-backdrop-filter:blur(10px)!important;backdrop-filter:blur(10px)!important;border:1px solid rgba(0,0,0,.1)!important;border-radius:8px!important}.search-card[data-v-81445cda]{margin-bottom:24px;box-shadow:0 8px 32px #00000014;border-radius:16px;background:#fff;transition:all .3s ease;position:relative;overflow:visible}.search-card[data-v-81445cda]:hover{box-shadow:0 12px 48px #0000001f}html.dark .search-card[data-v-81445cda]{background:#1f1f1f;box-shadow:0 8px 32px #0000004d;color:#fff}html.dark .search-card[data-v-81445cda]:hover{box-shadow:0 12px 48px #0006}.platforms-card[data-v-81445cda]{margin-bottom:40px;box-shadow:0 8px 32px #00000014;border-radius:16px;background:#fff;transition:all .3s ease}.platforms-card[data-v-81445cda]:hover{box-shadow:0 12px 48px #0000001f}.search-form[data-v-81445cda]{max-width:800px;margin:0 auto;padding:40px 0;text-align:center}.search-header-section[data-v-81445cda]{display:flex;align-items:center;justify-content:center;gap:12px;margin-bottom:24px;padding:0;background:none;border:none;color:#333;border-radius:0;width:100%;box-sizing:border-box;position:relative}.theme-toggle-button[data-v-81445cda]{position:absolute;top:16px;left:16px;margin-left:0;z-index:10;background:transparent;border:1px solid rgba(245,34,45,.3);border-radius:8px;padding:4px 8px;box-shadow:none;transition:all .3s ease;font-size:14px;display:flex;align-items:center;justify-content:center;line-height:1.5;height:auto;min-height:24px;color:#333}.theme-toggle-button[data-v-81445cda]:hover{color:var(--primary-color);background:#f5222d1a;border-color:#f5222d66;box-shadow:none}html.dark .theme-toggle-button[data-v-81445cda]{background:transparent;border:1px solid rgba(255,255,255,.1);color:#ffffffa6}html.dark .theme-toggle-button[data-v-81445cda]:hover{background:#f5222d33;color:var(--primary-color);border-color:#f5222d4d}.toggle-search-mode-button[data-v-81445cda]{position:absolute;top:16px;right:16px;margin-left:0;z-index:10;background:transparent;border:1px solid rgba(245,34,45,.3);border-radius:8px;padding:4px 8px;box-shadow:none;transition:all .3s ease;font-size:14px;display:flex;align-items:center;justify-content:center;line-height:1.5;height:auto;min-height:24px;color:#333}.toggle-search-mode-button[data-v-81445cda]:hover{color:var(--primary-color);background:#f5222d1a;border-color:#f5222d66;box-shadow:none}html.dark .toggle-search-mode-button[data-v-81445cda]{background:transparent;border:1px solid rgba(255,255,255,.1);color:#ffffffa6}html.dark .toggle-search-mode-button[data-v-81445cda]:hover{background:#f5222d33;color:var(--primary-color);border-color:#f5222d4d}.search-header-title[data-v-81445cda]{font-size:3em;font-weight:700;margin:0;background:var(--primary-gradient);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent}.search-mode-content[data-v-81445cda],.chatbot-mode-content[data-v-81445cda]{width:100%}.search-title[data-v-81445cda]{font-size:2em;margin-bottom:8px;background:var(--primary-gradient);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent}.search-description[data-v-81445cda]{font-size:1.1em;margin-bottom:24px;color:#666}html.dark .search-description[data-v-81445cda]{color:#ffffffa6}.home-footer[data-v-81445cda]{background:var(--primary-gradient);color:#fff;text-align:center;padding:20px 0;opacity:.5;display:flex;justify-content:center;align-items:center}html.dark .home-footer[data-v-81445cda]{background:#1f1f1f!important;color:#ffffffa6!important;opacity:1!important}.home-footer p[data-v-81445cda]{margin:0}.home-footer[data-v-81445cda] a{color:#fff!important}.home-footer[data-v-81445cda]:hover{opacity:1}html.dark .home-footer[data-v-81445cda]:hover{opacity:.9!important}.footer-content[data-v-81445cda]{max-width:1200px;margin:0 auto;padding:0 20px}`)),document.head.appendChild(a)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { defineComponent as ke, ref as Y, onMounted as Ue, computed as J, watch as se, resolveComponent as C, createElementBlock as g, openBlock as c, createElementVNode as e, createVNode as n, createTextVNode as k, toDisplayString as l, unref as t, isRef as Be, withCtx as s, Fragment as O, renderList as N, createBlock as S, normalizeClass as De, createCommentVNode as F, renderSlot as pe, withKeys as Xe, withModifiers as Me } from "vue";
import { pluginManager as Ze } from "@gitcoffee/plugins";
import { $t as i, useCurrentLanguage as Oe, setLanguage as et, useI18n as tt, getLanguageName as Ce, supportedLanguages as at } from "@gitcoffee/i18n";
import { allPlatforms as ze, categories as st, getPlatformsByCategory as ue, selectedCategory as te, selectedPlatforms as U, displayMode as ie, selectAllPlatforms as ye, selectedTags as ce, tagDefinitions as Ne, getFaviconUrl as _e, searchEngines as fe, useSearchStore as Fe, defaultSettingData as Ae, saveSettingsToStorage as qe, movePlatform as nt, handlePlatformEnabledChange as ot, moveTag as lt, handleTagEnabledChange as it } from "@gitcoffee/search";
import { message as Pe, Input as ct, Button as Ee, Tabs as rt, TabPane as me, Spin as dt, Alert as ut, Empty as gt, Pagination as ht } from "@gitcoffee/design-ui";
import { SearchOutlined as vt, RobotOutlined as mt, GlobalOutlined as pt, PictureOutlined as ft, FileTextOutlined as _t, VideoCameraOutlined as yt, EnvironmentOutlined as bt, MoreOutlined as kt } from "@gitcoffee/icons";
import { useRoute as St, useRouter as wt } from "vue-router";
import { waitForPinia as Ct, settingData as be } from "@gitcoffee/app";
import { useAuth as q } from "@gitcoffee/auth";
const $t = { class: "platform-selection-controls" }, Kt = { class: "control-left" }, xt = { class: "selected-count" }, Tt = { class: "count-number" }, Dt = { class: "control-center" }, Et = { class: "control-right" }, Ut = { class: "platform-tags-selection" }, Pt = { class: "tags-title" }, Lt = { class: "tags-container" }, It = { key: 0 }, Rt = { class: "platforms-list" }, Bt = { class: "platforms-checkbox-group" }, Mt = { class: "platform-item" }, zt = { class: "platform-name" }, At = ["src", "alt"], qt = { class: "platform-description" }, Ot = { key: 1 }, Nt = { class: "category-display" }, Ft = { class: "category-header" }, Qt = { class: "category-title" }, Wt = { class: "category-select-all" }, Ht = { class: "platforms-checkbox-group" }, Vt = ["src", "alt"], Gt = { key: 2 }, jt = { class: "grid-display" }, Yt = { class: "grid-checkbox-group" }, Jt = ["onClick"], Xt = { class: "grid-item-icon" }, Zt = { class: "grid-item-name" }, ea = ["src", "alt"], ta = { class: "grid-item-category" }, aa = { key: 3 }, sa = { class: "list-display" }, na = { class: "list-checkbox-group" }, oa = { class: "list-wrapper" }, la = ["onClick"], ia = { class: "list-item-checkbox" }, ca = { class: "list-item-icon" }, ra = { class: "list-item-main" }, da = { class: "list-item-info" }, ua = { class: "list-item-name" }, ga = ["src", "alt"], ha = { class: "list-item-category" }, va = { class: "list-item-description" }, ma = /* @__PURE__ */ ke({
  __name: "SmartSearch",
  props: {
    settingData: {}
  },
  emits: ["platformsSelected"],
  setup(P, { emit: ne }) {
    const _ = P, z = ne, $ = Y([]), A = Y(!0);
    Ue(async () => {
      try {
        A.value = !0;
        const p = await Ze.getAllPlatforms();
        $.value = p, $.value.length === 0 && ($.value = ze);
      } catch (p) {
        console.error("Failed to load platforms:", p), $.value = ze;
      } finally {
        A.value = !1;
      }
    });
    const u = st, B = J(() => u.filter((p) => ue(p.name).length > 0)), h = B, r = J(() => {
      const p = typeof chrome < "u" && chrome.runtime && chrome.runtime.getURL;
      let y = (_.settingData.searchPlatforms || []).filter((K) => K.enabled);
      if (p || te.value === "AI对话" && (y = y.filter(
        (D) => D.type !== "grid" && D.type !== "list"
      )), y.length === 0) {
        let K = [
          { type: "tabs", enabled: !0, order: 1 },
          { type: "categories", enabled: !0, order: 2 },
          { type: "grid", enabled: !0, order: 3 },
          { type: "list", enabled: !0, order: 4 }
        ];
        return !(typeof chrome < "u" && chrome.runtime && chrome.runtime.getURL) && te.value === "AI对话" && (K = K.filter(
          (Q) => Q.type !== "grid" && Q.type !== "list"
        )), K;
      }
      return y.sort((K, D) => K.order - D.order);
    }), H = J(() => {
      const p = /* @__PURE__ */ new Set();
      $.value.forEach((y) => {
        y.tags.forEach((K) => {
          p.add(K);
        });
      });
      const f = _.settingData.tags || [];
      return Array.from(p).filter((y) => f.find((D) => D.key === y)?.enabled !== !1).sort((y, K) => {
        const D = f.find((ee) => ee.key === y), Q = f.find((ee) => ee.key === K);
        return D && Q ? D.order - Q.order : D ? -1 : Q ? 1 : y.localeCompare(K);
      });
    }), w = (p) => {
      const f = h.value.find((y) => y.name === p);
      return f ? f.icon : "🔍";
    }, v = (p) => {
      switch (p) {
        case "tabs":
          return i("home.tabs");
        case "categories":
          return i("home.category");
        case "grid":
          return i("home.grid");
        case "list":
          return i("home.list");
        default:
          return p;
      }
    }, b = (p) => {
      U.value.indexOf(p) > -1 ? U.value = U.value.filter((y) => y !== p) : U.value = [...U.value, p], re(), z("platformsSelected", U.value);
    }, M = (p) => {
      const f = ue(p), y = f.map((D) => D.code);
      return U.value.filter(
        (D) => y.includes(D)
      ).length === f.length;
    }, ae = (p, f) => {
      const K = ue(p).map((Q) => Q.code), D = U.value.filter((Q) => {
        const ee = $.value.find((de) => de.code === Q);
        return ee && ee.category !== p;
      });
      f ? U.value = [...D, ...K] : U.value = D, re(), z("platformsSelected", U.value);
    }, oe = () => {
      ye.value = !ye.value;
      let p = [];
      ie.value === "tabs" ? p = ue(te.value) : p = $.value;
      const f = p.map((y) => y.code);
      ye.value ? U.value = [
        ...U.value.filter((y) => !f.includes(y)),
        ...f
      ] : U.value = U.value.filter(
        (y) => !f.includes(y)
      ), z("platformsSelected", U.value);
    }, ge = (p) => {
      ce.value.indexOf(p) > -1 ? ce.value = ce.value.filter((y) => y !== p) : ce.value = [...ce.value, p], he();
    }, he = () => {
      let p = [...$.value];
      if (ie.value === "tabs" && (p = ue(te.value)), ce.value.length === 0)
        U.value = U.value.filter((f) => {
          const y = $.value.find((K) => K.code === f);
          return y && y.category !== te.value;
        });
      else {
        const y = p.filter((K) => K.tags.some((D) => ce.value.includes(D))).map((K) => K.code);
        ie.value === "tabs" ? (U.value = U.value.filter(
          (K) => {
            const D = $.value.find((Q) => Q.code === K);
            return D && D.category !== te.value;
          }
        ), U.value.push(...y)) : U.value = y;
      }
      re(), z("platformsSelected", U.value);
    }, re = () => {
      let p = [];
      ie.value === "tabs" ? p = ue(te.value) : p = $.value;
      const f = p.map((K) => K.code), y = U.value.filter(
        (K) => f.includes(K)
      );
      ye.value = y.length === p.length;
    }, L = (p) => {
      te.value = p;
    };
    return se(
      () => B.value,
      (p) => {
        !p.some(
          (y) => y.name === te.value
        ) && p.length > 0 && (te.value = p[0].name);
      },
      { immediate: !0, deep: !0 }
    ), se(
      U,
      () => {
        re();
      },
      { deep: !0 }
    ), (p, f) => {
      const y = C("a-radio-button"), K = C("a-radio-group"), D = C("a-checkbox"), Q = C("a-tag"), ee = C("a-col"), de = C("a-row"), $e = C("a-tab-pane"), Ke = C("a-tabs"), we = C("a-card");
      return c(), g("div", null, [
        e("div", $t, [
          e("div", Kt, [
            k(l(t(i)("home.selectPlatforms")) + " ", 1),
            e("span", xt, [
              k(" (" + l(t(i)("home.selectedCountPrefix")) + " ", 1),
              e("span", Tt, l(t(U).length), 1),
              k(" " + l(t(i)("home.selectedCountSuffix")) + ") ", 1)
            ])
          ]),
          e("div", Dt, [
            n(K, {
              value: t(ie),
              "onUpdate:value": f[0] || (f[0] = (m) => Be(ie) ? ie.value = m : null),
              "button-style": "solid"
            }, {
              default: s(() => [
                (c(!0), g(O, null, N(r.value, (m) => (c(), S(y, {
                  key: m.type,
                  value: m.type === "categories" ? "category" : m.type
                }, {
                  default: s(() => [
                    k(l(v(m.type)), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          e("div", Et, [
            n(D, {
              checked: t(ye),
              onChange: oe
            }, {
              default: s(() => [
                k(l(t(i)("home.selectAll")), 1)
              ]),
              _: 1
            }, 8, ["checked"])
          ])
        ]),
        e("div", Ut, [
          e("div", Pt, l(t(i)("home.selectByTag")) + "：", 1),
          e("div", Lt, [
            (c(!0), g(O, null, N(H.value, (m) => (c(), S(Q, {
              key: m,
              color: t(ce).includes(m) ? "var(--primary-color)" : "",
              closable: !1,
              checked: t(ce).includes(m),
              onClick: (x) => ge(m),
              class: De([
                "platform-tag",
                {
                  "tag-selected": t(ce).includes(m),
                  "tag-outline": !t(ce).includes(m)
                }
              ])
            }, {
              default: s(() => [
                k(l(t(Ne).find((x) => x.key === m)?.name || m), 1)
              ]),
              _: 2
            }, 1032, ["color", "checked", "onClick", "class"]))), 128))
          ])
        ]),
        n(we, {
          class: "platforms-card",
          bordered: !1
        }, {
          default: s(() => [
            t(ie) === "tabs" ? (c(), g("div", It, [
              n(Ke, {
                activeKey: t(te),
                "onUpdate:activeKey": f[3] || (f[3] = (m) => Be(te) ? te.value = m : null),
                onChange: L
              }, {
                default: s(() => [
                  (c(!0), g(O, null, N(t(h), (m) => (c(), S($e, {
                    key: m.name,
                    tab: m.icon + " " + m.name
                  }, {
                    default: s(() => [
                      e("div", Rt, [
                        e("div", Bt, [
                          n(de, { gutter: [16, 16] }, {
                            default: s(() => [
                              (c(!0), g(O, null, N(t(ue)(
                                m.name
                              ), (x) => (c(), S(ee, {
                                xs: 24,
                                sm: 12,
                                md: 8,
                                lg: 8,
                                key: x.name
                              }, {
                                default: s(() => [
                                  n(D, {
                                    checked: t(U).includes(x.code),
                                    onChange: (I) => b(x.code)
                                  }, {
                                    default: s(() => [
                                      e("div", Mt, [
                                        e("div", zt, [
                                          e("img", {
                                            src: t(_e)(x.url),
                                            alt: x.name + " favicon",
                                            class: "platform-favicon",
                                            loading: "lazy",
                                            onLoad: f[1] || (f[1] = (I) => {
                                              const V = I.target;
                                              V && (V.style.backgroundImage = "none");
                                            }),
                                            onError: f[2] || (f[2] = (I) => {
                                              const V = I.target;
                                              V && (V.src = "data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><text x='0.5em' y='1em' font-size='12'>🔍</text></svg>", V.style.backgroundImage = "none");
                                            })
                                          }, null, 40, At),
                                          k(" " + l(x.name), 1)
                                        ]),
                                        e("div", qt, l(x.description), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["checked", "onChange"])
                                ]),
                                _: 2
                              }, 1024))), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["tab"]))), 128))
                ]),
                _: 1
              }, 8, ["activeKey"])
            ])) : t(ie) === "category" ? (c(), g("div", Ot, [
              e("div", Nt, [
                (c(!0), g(O, null, N(t(h), (m) => (c(), g("div", {
                  key: m.name,
                  class: "category-section"
                }, [
                  e("div", Ft, [
                    e("h3", Qt, l(m.icon) + " " + l(m.name), 1),
                    e("div", Wt, [
                      n(D, {
                        checked: M(m.name),
                        onChange: (x) => {
                          const I = x.target;
                          ae(
                            m.name,
                            I?.checked || !1
                          );
                        }
                      }, {
                        default: s(() => [
                          k(l(t(i)("home.selectAll")), 1)
                        ]),
                        _: 1
                      }, 8, ["checked", "onChange"])
                    ])
                  ]),
                  e("div", Ht, [
                    n(de, { gutter: [16, 16] }, {
                      default: s(() => [
                        (c(!0), g(O, null, N(t(ue)(
                          m.name
                        ), (x) => (c(), S(ee, {
                          xs: 24,
                          sm: 12,
                          md: 8,
                          lg: 8,
                          key: x.name
                        }, {
                          default: s(() => [
                            n(D, {
                              checked: t(U).includes(x.code),
                              onChange: (I) => b(x.code)
                            }, {
                              default: s(() => [
                                e("img", {
                                  src: t(_e)(x.url),
                                  alt: x.name + " favicon",
                                  class: "platform-favicon",
                                  loading: "lazy",
                                  onLoad: f[4] || (f[4] = (I) => {
                                    const V = I.target;
                                    V && (V.style.backgroundImage = "none");
                                  }),
                                  onError: f[5] || (f[5] = (I) => {
                                    const V = I.target;
                                    V && (V.src = "data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><text x='0.5em' y='1em' font-size='12'>🔍</text></svg>", V.style.backgroundImage = "none");
                                  })
                                }, null, 40, Vt),
                                k(" " + l(x.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["checked", "onChange"])
                          ]),
                          _: 2
                        }, 1024))), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))), 128))
              ])
            ])) : t(ie) === "grid" ? (c(), g("div", Gt, [
              e("div", jt, [
                e("div", Yt, [
                  n(de, { gutter: [16, 16] }, {
                    default: s(() => [
                      (c(!0), g(O, null, N($.value.filter((m) => m.category !== "AI对话"), (m) => (c(), S(ee, {
                        xs: 12,
                        sm: 8,
                        md: 6,
                        lg: 6,
                        key: m.name
                      }, {
                        default: s(() => [
                          e("div", {
                            class: De(["grid-item", {
                              selected: t(U).includes(m.code)
                            }]),
                            onClick: (x) => b(m.code)
                          }, [
                            e("div", Xt, l(w(m.category)), 1),
                            e("div", Zt, [
                              e("img", {
                                src: t(_e)(m.url),
                                alt: m.name + " favicon",
                                class: "platform-favicon",
                                loading: "lazy",
                                onLoad: f[6] || (f[6] = (x) => {
                                  const I = x.target;
                                  I && (I.style.backgroundImage = "none");
                                }),
                                onError: f[7] || (f[7] = (x) => {
                                  const I = x.target;
                                  I && (I.src = "data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><text x='0.5em' y='1em' font-size='12'>🔍</text></svg>", I.style.backgroundImage = "none");
                                })
                              }, null, 40, ea),
                              k(" " + l(m.name), 1)
                            ]),
                            e("div", ta, l(m.category), 1)
                          ], 10, Jt)
                        ]),
                        _: 2
                      }, 1024))), 128))
                    ]),
                    _: 1
                  })
                ])
              ])
            ])) : t(ie) === "list" ? (c(), g("div", aa, [
              e("div", sa, [
                e("div", na, [
                  e("div", oa, [
                    (c(!0), g(O, null, N($.value.filter((m) => m.category !== "AI对话"), (m) => (c(), g("div", {
                      key: m.name,
                      class: "list-platform-wrapper"
                    }, [
                      e("div", {
                        class: De(["list-item", {
                          selected: t(U).includes(m.name)
                        }]),
                        onClick: (x) => b(m.name)
                      }, [
                        e("div", ia, [
                          n(D, {
                            checked: t(U).includes(m.name),
                            onChange: (x) => b(m.code)
                          }, null, 8, ["checked", "onChange"])
                        ]),
                        e("div", ca, l(w(m.category)), 1),
                        e("div", ra, [
                          e("div", da, [
                            e("div", ua, [
                              e("img", {
                                src: t(_e)(m.url),
                                alt: m.name + " favicon",
                                class: "platform-favicon",
                                loading: "lazy",
                                onLoad: f[8] || (f[8] = (x) => {
                                  const I = x.target;
                                  I && (I.style.backgroundImage = "none");
                                }),
                                onError: f[9] || (f[9] = (x) => {
                                  const I = x.target;
                                  I && (I.src = "data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><text x='0.5em' y='1em' font-size='12'>🔍</text></svg>", I.style.backgroundImage = "none");
                                })
                              }, null, 40, ga),
                              k(" " + l(m.name), 1)
                            ]),
                            e("div", ha, l(m.category), 1)
                          ]),
                          e("div", va, l(m.description), 1)
                        ])
                      ], 10, la)
                    ]))), 128))
                  ])
                ])
              ])
            ])) : F("", !0)
          ]),
          _: 1
        })
      ]);
    };
  }
}), Se = (P, ne) => {
  const _ = P.__vccOpts || P;
  for (const [z, $] of ne)
    _[z] = $;
  return _;
}, pa = /* @__PURE__ */ Se(ma, [["__scopeId", "data-v-073e9c39"]]), fa = { class: "search-box-container" }, _a = {
  key: 0,
  class: "search-engine-selector"
}, ya = { key: 0 }, ba = ["src", "alt"], ka = {
  key: 1,
  class: "search-engine-icon"
}, Sa = { class: "search-engine-name" }, wa = {
  key: 0,
  class: "search-icon-dropdown"
}, Ca = { class: "search-icon-dropdown" }, $a = ["src", "alt"], Ka = { key: 1 }, xa = { class: "search-engine-option-content" }, Ta = { key: 0 }, Da = ["src", "alt"], Ea = {
  key: 1,
  class: "search-engine-icon"
}, Ua = { class: "search-engine-name" }, Pa = /* @__PURE__ */ ke({
  __name: "SearchBox",
  props: {
    settingData: {},
    searchQuery: {},
    selectedSearchEngine: {},
    loading: { type: Boolean },
    searching: { type: Boolean },
    selectedPlatforms: {}
  },
  emits: ["search", "update:searchQuery", "update:selectedSearchEngine"],
  setup(P, { emit: ne }) {
    const _ = P, z = ne, $ = Y(_.searchQuery), A = () => (fe.find((b) => b.defaulted) || fe[0]).name, u = Y(_.selectedSearchEngine || A()), B = J(() => _.searching !== void 0 ? _.searching : _.loading || !1);
    se(
      () => _.searchQuery,
      (v) => {
        $.value = v;
      }
    ), se(
      () => _.selectedSearchEngine,
      (v) => {
        u.value = v;
      }
    ), se(
      () => _.settingData?.smartSearchEnabled,
      (v, b) => {
        if (v !== b) {
          const M = A();
          ["百度", "默认搜索"].includes(u.value) && (u.value = M);
        }
      }
    ), se(
      $,
      (v) => {
        z("update:searchQuery", v);
      }
    ), se(
      u,
      (v) => {
        z("update:selectedSearchEngine", v);
      }
    );
    const h = J(() => fe.find((v) => v.name === u.value) || fe[0] || {
      name: "百度",
      code: "baidu",
      icon: "🔍",
      url: "https://www.baidu.com/s",
      searchParam: "wd",
      iconUrl: ""
    }), r = J(() => h.value.icon || "🔍"), H = async () => {
      const v = $.value.trim();
      if (!v) {
        Pe.warning(i("search.pleaseEnterKeyword"));
        return;
      }
      const b = h.value;
      _.settingData ? _.settingData?.smartSearchEnabled ? z("search", v, u.value) : z("search", v, u.value, b.apiEnabled) : z("search", v, u.value);
    }, w = (v) => {
      const b = v.target;
      b && (b.src = "data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><text x='50%' y='80%' text-anchor='middle' dominant-baseline='middle' font-size='20'>🔍</text></svg>", b.style.width = "24px", b.style.height = "24px");
    };
    return (v, b) => {
      const M = C("a-select-option"), ae = C("a-select"), oe = C("a-menu-item"), ge = C("a-menu"), he = C("a-dropdown"), re = C("a-input-search");
      return c(), g("div", fa, [
        _.settingData?.showSearchEngineSelector && !_.settingData?.smartSearchEnabled ? (c(), g("div", _a, [
          n(ae, {
            value: u.value,
            "onUpdate:value": b[0] || (b[0] = (L) => u.value = L),
            size: "large",
            style: { width: "200px", "margin-bottom": "16px" }
          }, {
            default: s(() => [
              (c(!0), g(O, null, N(t(fe), (L) => (c(), S(M, {
                key: L.name,
                value: L.name
              }, {
                default: s(() => [
                  e("div", null, [
                    L.iconUrl ? (c(), g("span", ya, [
                      e("img", {
                        src: L.iconUrl,
                        class: "search-engine-img",
                        alt: L.name,
                        onError: w
                      }, null, 40, ba)
                    ])) : (c(), g("span", ka, l(L.icon), 1)),
                    e("span", Sa, l(L.name), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["value"]))), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ])) : F("", !0),
        n(re, {
          value: $.value,
          "onUpdate:value": b[2] || (b[2] = (L) => $.value = L),
          placeholder: t(i)("home.searchPlaceholder"),
          "enter-button": t(i)("home.searchButton"),
          size: "large",
          allowClear: !0,
          onSearch: H,
          class: "search-input",
          loading: B.value
        }, {
          prefix: s(() => [
            _.settingData?.smartSearchEnabled ? (c(), g("a", wa, [...b[3] || (b[3] = [
              e("span", null, "🔍", -1)
            ])])) : (c(), S(he, { key: 1 }, {
              overlay: s(() => [
                n(ge, {
                  selectedKeys: [u.value],
                  onClick: b[1] || (b[1] = ({ key: L }) => u.value = L)
                }, {
                  default: s(() => [
                    (c(!0), g(O, null, N(t(fe), (L) => (c(), S(oe, {
                      key: L.name
                    }, {
                      default: s(() => [
                        e("div", xa, [
                          L.iconUrl ? (c(), g("span", Ta, [
                            e("img", {
                              src: L.iconUrl,
                              class: "search-engine-img",
                              alt: L.name,
                              onError: w
                            }, null, 40, Da)
                          ])) : (c(), g("span", Ea, l(L.icon), 1)),
                          e("span", Ua, l(L.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024))), 128))
                  ]),
                  _: 1
                }, 8, ["selectedKeys"])
              ]),
              default: s(() => [
                e("a", Ca, [
                  h.value.iconUrl ? (c(), g("img", {
                    key: 0,
                    src: h.value.iconUrl,
                    class: "search-engine-img",
                    alt: h.value.name,
                    onError: w
                  }, null, 40, $a)) : (c(), g("span", Ka, l(r.value), 1))
                ])
              ]),
              _: 1
            }))
          ]),
          _: 1
        }, 8, ["value", "placeholder", "enter-button", "loading"])
      ]);
    };
  }
}), mo = /* @__PURE__ */ Se(Pa, [["__scopeId", "data-v-b4c81e84"]]), La = { class: "seekflow-search-container" }, Ia = { class: "seekflow-search-header" }, Ra = { class: "header-content" }, Ba = { class: "seekflow-logo" }, Ma = { class: "search-box-container" }, za = { class: "setting-button-wrapper" }, Aa = { class: "seekflow-tabs" }, qa = { class: "tab-content" }, Oa = { class: "tab-content" }, Na = { class: "tab-content" }, Fa = { class: "tab-content" }, Qa = { class: "tab-content" }, Wa = { class: "tab-content" }, Ha = { class: "tab-content" }, Va = { class: "seekflow-main-content" }, Ga = { class: "search-results-column" }, ja = { class: "search-info" }, Ya = { key: 0 }, Ja = { class: "search-results-list" }, Xa = {
  key: 0,
  class: "loading-state"
}, Za = {
  key: 1,
  class: "error-state"
}, es = {
  key: 2,
  class: "empty-state"
}, ts = {
  key: 3,
  class: "results-list"
}, as = { class: "result-url-container" }, ss = { class: "site-info" }, ns = { class: "site-details" }, os = { class: "site-name" }, ls = { class: "result-url" }, is = ["href"], cs = { class: "result-description" }, rs = {
  key: 0,
  class: "pagination-container"
}, ds = {
  key: 0,
  class: "related-content-column"
}, us = {
  key: 0,
  class: "related-searches"
}, gs = { class: "related-searches-title" }, hs = { class: "related-searches-list" }, vs = ["href"], ms = {
  key: 1,
  class: "related-content"
}, ps = { class: "related-content-title" }, fs = { class: "related-content-list" }, _s = { class: "related-content-number" }, ys = ["href"], bs = /* @__PURE__ */ ke({
  __name: "SearchResults",
  props: {
    searchApiConfig: {},
    iconUrl: {},
    showSettingModal: { type: Boolean, default: !1 },
    showRightColumn: { type: Boolean, default: !1 },
    aiTabUrl: { default: "/chat" }
  },
  emits: ["update:showSettingModal"],
  setup(P, { emit: ne }) {
    const _ = P, z = ne, $ = St(), A = wt(), u = Fe();
    return u.setApiConfig(_.searchApiConfig), Ue(() => {
      const B = $.query.q, h = $.query.engine;
      if (B) {
        if (u.setSearchQuery(B), h) {
          const H = {
            百度: "https://www.baidu.com/s?wd={q}",
            搜狗搜索: "https://www.sogou.com/web?query={q}",
            "Perplexity AI": "https://www.perplexity.ai/search?q={q}",
            "You.com": "https://you.com/search?q={q}",
            Kagi: "https://kagi.com/search?q={q}",
            "ChatGPT Search": "https://chat.openai.com/search?q={q}",
            "Gemini Search": "https://gemini.google.com/search?q={q}",
            "Bing AI": "https://www.bing.com/chat?q={q}"
          }[h];
          if (H) {
            window.location.href = H.replace("{q}", encodeURIComponent(B));
            return;
          }
        }
        u.fetchSearchResults();
      } else
        A.push("/"), Pe.warning(i("searchResults.noQuery"));
    }), se(() => u.searchQuery, (B) => {
      B && (u.setCurrentPage(1), u.fetchSearchResults());
    }), se(() => u.currentPage, () => {
      u.fetchSearchResults(), window.scrollTo({ top: 0, behavior: "smooth" });
    }), se(() => u.activeTabKey, (B) => {
      u.resetSearchState(), B === "ai" ? _.aiTabUrl.startsWith("http://") || _.aiTabUrl.startsWith("https://") ? window.location.href = _.aiTabUrl : A.push(_.aiTabUrl) : B === "all" && u.searchQuery && u.fetchSearchResults();
    }), (B, h) => {
      const r = C("a-avatar"), H = C("router-link");
      return c(), g("div", La, [
        e("div", Ia, [
          e("div", Ra, [
            e("div", Ba, [
              n(H, {
                to: "/",
                class: "logo-link"
              }, {
                default: s(() => [
                  n(r, {
                    src: P.iconUrl,
                    size: 48
                  }, null, 8, ["src"])
                ]),
                _: 1
              })
            ]),
            e("div", Ma, [
              n(t(ct), {
                value: t(u).searchQuery,
                "onUpdate:value": h[0] || (h[0] = (w) => t(u).searchQuery = w),
                onKeypress: Xe(t(u).fetchSearchResults, ["enter"]),
                placeholder: "搜索",
                class: "seekflow-search-input",
                allowClear: !0
              }, {
                suffix: s(() => [
                  n(t(Ee), {
                    type: "text",
                    class: "search-button",
                    onClick: t(u).fetchSearchResults
                  }, {
                    default: s(() => [
                      n(t(vt), { class: "search-icon" })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["value", "onKeypress"])
            ]),
            e("div", za, [
              n(t(Ee), {
                type: "text",
                class: "setting-button",
                onClick: h[1] || (h[1] = (w) => z("update:showSettingModal", !0))
              }, {
                default: s(() => [
                  k(" ⚙️ " + l(t(i)("common.setting")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          e("div", Aa, [
            n(t(rt), {
              activeKey: t(u).activeTabKey,
              "onUpdate:activeKey": h[2] || (h[2] = (w) => t(u).activeTabKey = w),
              class: "seekflow-tabs-container",
              bordered: !1,
              size: "large",
              onChange: t(u).setActiveTabKey
            }, {
              default: s(() => [
                n(t(me), { key: "ai" }, {
                  tab: s(() => [
                    e("div", qa, [
                      n(t(mt), {
                        class: "tab-icon",
                        style: { stroke: "var(--primary-color)" }
                      }),
                      e("span", null, l(t(i)("searchResults.tabs.ai")), 1)
                    ])
                  ]),
                  default: s(() => [
                    h[4] || (h[4] = e("div", { class: "tab-pane-content" }, null, -1))
                  ]),
                  _: 1
                }),
                n(t(me), { key: "all" }, {
                  tab: s(() => [
                    e("div", Oa, [
                      n(t(pt), {
                        class: "tab-icon",
                        style: { stroke: "var(--primary-color)" }
                      }),
                      e("span", null, l(t(i)("searchResults.tabs.all")), 1)
                    ])
                  ]),
                  default: s(() => [
                    h[5] || (h[5] = e("div", { class: "tab-pane-content" }, null, -1))
                  ]),
                  _: 1
                }),
                n(t(me), { key: "images" }, {
                  tab: s(() => [
                    e("div", Na, [
                      n(t(ft), { class: "tab-icon" }),
                      e("span", null, l(t(i)("searchResults.tabs.images")), 1)
                    ])
                  ]),
                  default: s(() => [
                    h[6] || (h[6] = e("div", { class: "tab-pane-content" }, null, -1))
                  ]),
                  _: 1
                }),
                n(t(me), { key: "news" }, {
                  tab: s(() => [
                    e("div", Fa, [
                      n(t(_t), { class: "tab-icon" }),
                      e("span", null, l(t(i)("searchResults.tabs.news")), 1)
                    ])
                  ]),
                  default: s(() => [
                    h[7] || (h[7] = e("div", { class: "tab-pane-content" }, null, -1))
                  ]),
                  _: 1
                }),
                n(t(me), { key: "videos" }, {
                  tab: s(() => [
                    e("div", Qa, [
                      n(t(yt), { class: "tab-icon" }),
                      e("span", null, l(t(i)("searchResults.tabs.videos")), 1)
                    ])
                  ]),
                  default: s(() => [
                    h[8] || (h[8] = e("div", { class: "tab-pane-content" }, null, -1))
                  ]),
                  _: 1
                }),
                n(t(me), { key: "maps" }, {
                  tab: s(() => [
                    e("div", Wa, [
                      n(t(bt), { class: "tab-icon" }),
                      e("span", null, l(t(i)("searchResults.tabs.maps")), 1)
                    ])
                  ]),
                  default: s(() => [
                    h[9] || (h[9] = e("div", { class: "tab-pane-content" }, null, -1))
                  ]),
                  _: 1
                }),
                n(t(me), { key: "more" }, {
                  tab: s(() => [
                    e("div", Ha, [
                      n(t(kt), { class: "tab-icon" }),
                      e("span", null, l(t(i)("searchResults.tabs.more")), 1)
                    ])
                  ]),
                  default: s(() => [
                    h[10] || (h[10] = e("div", { class: "tab-pane-content" }, null, -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey", "onChange"])
          ])
        ]),
        e("div", Va, [
          e("div", Ga, [
            e("div", ja, [
              t(u).totalResults > 0 ? (c(), g("p", Ya, l(t(i)("searchResults.totalResults", { count: t(u).totalResults })), 1)) : F("", !0)
            ]),
            e("div", Ja, [
              t(u).loading ? (c(), g("div", Xa, [
                n(t(dt), {
                  tip: t(i)("searchResults.loading"),
                  size: "large"
                }, {
                  default: s(() => [...h[11] || (h[11] = [
                    e("div", { class: "loading-content" }, null, -1)
                  ])]),
                  _: 1
                }, 8, ["tip"])
              ])) : t(u).error ? (c(), g("div", Za, [
                n(t(ut), {
                  message: t(i)("searchResults.error"),
                  description: t(u).error,
                  type: "error",
                  "show-icon": ""
                }, null, 8, ["message", "description"]),
                n(t(Ee), {
                  type: "primary",
                  onClick: t(u).fetchSearchResults
                }, {
                  default: s(() => [
                    k(l(t(i)("searchResults.retry")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])) : t(u).searchResults.length === 0 ? (c(), g("div", es, [
                n(t(gt), {
                  description: t(i)("searchResults.noResults")
                }, null, 8, ["description"])
              ])) : (c(), g("div", ts, [
                (c(!0), g(O, null, N(t(u).searchResults, (w, v) => (c(), g("div", {
                  key: w.id,
                  class: "result-item"
                }, [
                  e("div", as, [
                    e("div", ss, [
                      t(_e)(w.url) ? (c(), S(r, {
                        key: 0,
                        src: t(_e)(w.url),
                        class: "site-favicon",
                        alt: w.source,
                        size: 36
                      }, null, 8, ["src", "alt"])) : F("", !0),
                      e("div", ns, [
                        e("span", os, l(w.source), 1),
                        e("span", ls, l(w.url), 1)
                      ])
                    ])
                  ]),
                  e("a", {
                    href: w.url,
                    target: "_blank",
                    class: "result-title"
                  }, l(w.title), 9, is),
                  e("div", cs, l(w.description), 1)
                ]))), 128))
              ]))
            ]),
            t(u).totalResults > t(u).pageSize ? (c(), g("div", rs, [
              n(t(ht), {
                current: t(u).currentPage,
                "onUpdate:current": h[3] || (h[3] = (w) => t(u).currentPage = w),
                "page-size": t(u).pageSize,
                total: t(u).totalResults,
                "show-size-changer": !1,
                "hide-on-single-page": !0,
                onChange: t(u).setCurrentPage
              }, null, 8, ["current", "page-size", "total", "onChange"])
            ])) : F("", !0)
          ]),
          _.showRightColumn ? (c(), g("div", ds, [
            t(u).relatedSearches.length > 0 ? (c(), g("div", us, [
              e("h3", gs, l(t(i)("searchResults.relatedSearches")), 1),
              e("div", hs, [
                (c(!0), g(O, null, N(t(u).relatedSearches, (w, v) => (c(), g("a", {
                  key: v,
                  href: `/search?q=${encodeURIComponent(w)}`,
                  class: "related-search-item"
                }, l(w), 9, vs))), 128))
              ])
            ])) : (c(), g("div", ms, [
              e("h3", ps, l(t(i)("searchResults.relatedContentTitle")), 1),
              e("div", fs, [
                (c(), g(O, null, N(10, (w) => e("div", {
                  class: "related-content-item",
                  key: w
                }, [
                  e("span", _s, l(w) + ".", 1),
                  e("a", {
                    href: `/search?q=${encodeURIComponent(t(u).searchQuery + " " + w)}`,
                    class: "related-content-link"
                  }, l(t(u).searchQuery) + " " + l(w), 9, ys)
                ])), 64))
              ])
            ]))
          ])) : F("", !0)
        ]),
        pe(B.$slots, "user-setting", {
          showSettingModal: _.showSettingModal,
          "update:showSettingModal": (w) => z("update:showSettingModal", w)
        }, void 0, !0)
      ]);
    };
  }
}), po = /* @__PURE__ */ Se(bs, [["__scopeId", "data-v-b99aceb4"]]), ks = { class: "setting-container" }, Ss = { class: "setting-content" }, ws = { class: "setting-item" }, Cs = { class: "market-info" }, $s = { class: "setting-content" }, Ks = { class: "setting-item" }, xs = { class: "feedback-actions" }, Ts = { class: "setting-item about-setting-item" }, Ds = { class: "setting-label" }, Es = { class: "version-info" }, Us = { class: "setting-item about-setting-item" }, Ps = { class: "setting-label" }, Ls = ["href"], Is = { class: "setting-item about-setting-item" }, Rs = { class: "setting-label" }, Bs = ["href"], Ms = { class: "setting-item about-setting-item" }, zs = { class: "setting-label" }, As = ["href"], qs = { class: "setting-content" }, Os = { class: "setting-item" }, Ns = { class: "setting-label" }, Fs = { class: "setting-item" }, Qs = { class: "setting-label" }, Ws = {
  key: 0,
  class: "setting-item"
}, Hs = { class: "setting-label" }, Vs = { class: "setting-item" }, Gs = { class: "setting-label" }, js = {
  key: 0,
  class: "setting-item"
}, Ys = { class: "setting-label" }, Js = { class: "setting-item" }, Xs = { class: "setting-label" }, Zs = { class: "setting-content" }, en = { class: "setting-item" }, tn = { class: "setting-label" }, an = { class: "setting-item" }, sn = { class: "setting-label" }, nn = {
  key: 0,
  class: "setting-item"
}, on = { class: "setting-label" }, ln = { class: "setting-item" }, cn = { class: "setting-label" }, rn = {
  key: 0,
  class: "setting-item"
}, dn = { class: "setting-label" }, un = { class: "setting-item" }, gn = { class: "setting-label" }, hn = ["onDragstart", "onDragenter", "onDrop"], vn = { class: "platform-setting-content" }, mn = { class: "platform-name" }, pn = { class: "platform-controls" }, fn = { class: "setting-item" }, _n = { class: "setting-label" }, yn = ["onDragstart", "onDragenter", "onDrop"], bn = { class: "platform-setting-content" }, kn = { class: "platform-name" }, Sn = { class: "platform-controls" }, wn = { class: "setting-content" }, Cn = { class: "setting-item" }, $n = { class: "setting-label" }, Kn = { class: "setting-item" }, xn = { class: "setting-label" }, Tn = { class: "setting-item" }, Dn = { class: "backup-actions" }, En = { class: "setting-item" }, Un = { class: "setting-label" }, Pn = { class: "setting-item" }, Ln = { class: "setting-label" }, In = { class: "setting-item" }, Rn = { class: "setting-label" }, Bn = { class: "setting-content" }, Mn = { class: "setting-item" }, zn = { class: "setting-label" }, An = { class: "setting-item" }, qn = { class: "setting-label" }, On = /* @__PURE__ */ ke({
  __name: "SearchSetting",
  props: {
    supportedLanguages: {
      type: Array,
      required: !0
    },
    appInfo: {
      type: Object,
      default: () => ({
        version: "v1.0.0",
        officialWebsite: "https://searchfly.exmay.com/",
        openSourceCommunity: "https://github.com/gitcoffee-os",
        githubRepository: "https://github.com/gitcoffee-os/searchfly",
        rateApp: "https://github.com/gitcoffee-os/searchfly",
        submitFeedback: "https://github.com/gitcoffee-os/searchfly/issues"
      })
    }
  },
  emits: ["update:settingData"],
  setup(P, { emit: ne }) {
    const _ = P, z = ne, { isLoggedIn: $, login: A } = q(), u = [
      // 'enableLanguageSetting',
      // 'language',
      // 'enableThemeSetting',
      // 'theme',
      // 'openMode',
      // 'enableNotifications',
      // 'soundEnabled',
      // 'enableSmartSearch',
      // 'searchHistoryEnabled',
      // 'showSearchEngineSelector',
      // 'enableSearchTypeToggle',
      // 'defaultSearchType',
      // 'isBrowserTab'
    ], B = Y("profile"), h = Y(null), r = J(() => h.value?.settingData || Ae);
    J(() => h.value?.activeCollapseKeys || Ae.activeCollapseKeys), Ue(async () => {
      await Ct(), h.value = Fe(), await h.value?.initialize(), r.value.openMode || (r.value.openMode = "drawer");
    });
    const H = Y(""), w = Y(""), v = Y(""), b = Y(""), M = Y(!1), ae = Y(!1), oe = Y(!1), ge = async () => {
      await q().checkLogin() && (M.value = !0);
    }, he = async () => {
      await q().checkLogin() && (ae.value = !0);
    }, re = async () => {
      await q().checkLogin() && (oe.value = !0);
    }, L = J({
      get: () => r.value.autoBackupEnabled || !1,
      set: async (d) => {
        await q().checkLogin() && h.value && (h.value.updateSettingData({ autoBackupEnabled: d }), h.value.saveSettingsToStorage());
      }
    }), p = J({
      get: () => be.value.theme || "auto",
      set: async (d) => {
        if (await q().checkLogin()) {
          be.value.theme = d, h.value && h.value.updateSettingData({ theme: d }), qe();
          try {
            const { useTheme: a } = await import("@gitcoffee/app"), { setTheme: T } = a();
            T();
          } catch (a) {
            console.error("Error applying theme:", a);
          }
        }
      }
    }), f = J({
      get: () => Oe().value,
      set: async (d) => {
        await q().checkLogin() && (et(d), h.value && h.value.updateSettingData({ language: d }), qe());
      }
    }), y = async () => {
      await q().checkLogin();
    }, K = async () => {
      await q().checkLogin();
    }, D = () => {
      const d = _.appInfo.rateApp;
      typeof chrome < "u" && chrome.tabs ? chrome.tabs.create({ url: d }) : window.open(d, "_blank");
    }, Q = () => {
      const d = _.appInfo.submitFeedback;
      typeof chrome < "u" && chrome.tabs ? chrome.tabs.create({ url: d }) : window.open(d, "_blank");
    }, ee = J(() => r.value.searchPlatforms.sort((d, a) => d.order - a.order)), de = J(() => r.value.tags.sort((d, a) => d.order - a.order)), $e = (d) => {
      switch (d) {
        case "tabs":
          return i("setting.platformTabs");
        case "categories":
          return i("setting.platformCategories");
        case "grid":
          return i("setting.platformGrid");
        case "list":
          return i("setting.platformList");
        default:
          return d;
      }
    }, Ke = (d) => Ne.find((T) => T.key === d)?.name || d, we = async (d, a) => {
      await q().checkLogin() && nt(d, a);
    }, m = async (d, a) => {
      if (!await q().checkLogin() || !r.value) return;
      !ot(d, a) && !a && Pe.warning("至少需要保留一个显示方式");
    }, x = (d, a) => {
      H.value = a, d.dataTransfer?.setData("text/plain", a), d.target.classList.add("dragging");
    }, I = (d, a) => {
      w.value = a;
    }, V = (d) => {
      d.target.classList.remove("dragging"), H.value = "", w.value = "";
    }, Qe = async (d, a) => {
      if (!await q().checkLogin()) return;
      d.preventDefault();
      const T = H.value;
      if (!T || T === a)
        return;
      const E = r.value.searchPlatforms, Z = E.findIndex((le) => le.type === T), G = E.findIndex((le) => le.type === a);
      if (Z === -1 || G === -1)
        return;
      const j = E[Z].order, W = E[G].order;
      E[Z].order = W, E[G].order = j, h.value.saveSettingsToStorage(), H.value = "", w.value = "";
    }, Le = async (d, a) => {
      await q().checkLogin() && lt(d, a);
    }, We = async (d, a) => {
      await q().checkLogin() && r.value && it(d, a);
    }, He = (d, a) => {
      v.value = a, d.dataTransfer?.setData("text/plain", a), d.target.classList.add("dragging");
    }, Ve = (d, a) => {
      b.value = a;
    }, Ge = (d) => {
      d.target.classList.remove("dragging"), v.value = "", b.value = "";
    }, je = async (d, a) => {
      if (!await q().checkLogin()) return;
      d.preventDefault();
      const T = v.value;
      if (!T || T === a)
        return;
      const E = h.value.settingData.tags, Z = E.findIndex((le) => le.key === T), G = E.findIndex((le) => le.key === a);
      if (Z === -1 || G === -1)
        return;
      const j = E[Z].order, W = E[G].order;
      E[Z].order = W, E[G].order = j, h.value.saveSettingsToStorage(), v.value = "", b.value = "";
    }, Ye = async (d) => {
      await q().checkLogin() && (await X("smartSearchEnabled", d), d ? await X("showSearchEngineSelector", !1) : await X("showSearchEngineSelector", !0));
    }, X = async (d, a) => {
      !u.includes(String(d)) && !await q().checkLogin() || d in r.value && (h.value?.updateSettingData({ [d]: a }), h.value?.saveSettingsToStorage(), z("update:settingData", r.value), (d === "enableThemeSetting" || d === "theme" || d === "smartSearchEnabled" || d === "showSearchEngineSelector") && (be.value[d] = a));
    };
    return (d, a) => {
      const T = C("a-collapse-panel"), E = C("a-collapse"), Z = C("a-space"), G = C("a-tab-pane"), j = C("a-button"), W = C("a-switch"), le = C("a-select-option"), Ie = C("a-select"), ve = C("a-radio-button"), xe = C("a-radio-group"), Re = C("a-button-group"), Je = C("a-tabs"), Te = C("a-modal");
      return c(), g("div", ks, [
        n(Je, {
          activeKey: B.value,
          "onUpdate:activeKey": a[32] || (a[32] = (o) => B.value = o),
          class: "setting-tabs"
        }, {
          default: s(() => [
            (c(), S(G, {
              key: "market",
              tab: t(i)("setting.market")
            }, {
              default: s(() => [
                e("div", Ss, [
                  n(Z, {
                    direction: "vertical",
                    size: 16,
                    style: { width: "100%" }
                  }, {
                    default: s(() => [
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[0] || (a[0] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "market",
                            header: t(i)("setting.market")
                          }, {
                            default: s(() => [
                              e("div", ws, [
                                e("div", Cs, l(t(i)("setting.marketDescription")), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["tab"])),
            (c(), S(G, {
              key: "plugins",
              tab: t(i)("setting.plugins")
            }, {
              default: s(() => [
                pe(d.$slots, "plugin", {}, void 0, !0)
              ]),
              _: 3
            }, 8, ["tab"])),
            (c(), S(G, {
              key: "profile",
              tab: t(i)("setting.profile")
            }, {
              default: s(() => [
                e("div", $s, [
                  n(Z, {
                    direction: "vertical",
                    size: 16,
                    style: { width: "100%" }
                  }, {
                    default: s(() => [
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[1] || (a[1] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "account",
                            header: t(i)("setting.myAccount")
                          }, {
                            default: s(() => [
                              pe(d.$slots, "account-profile", {}, void 0, !0)
                            ]),
                            _: 3
                          }, 8, ["header"]))
                        ]),
                        _: 3
                      }, 8, ["activeKey"]),
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[2] || (a[2] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "feedback",
                            header: t(i)("setting.rateAndFeedback")
                          }, {
                            default: s(() => [
                              e("div", Ks, [
                                e("div", xs, [
                                  n(j, { onClick: D }, {
                                    default: s(() => [
                                      k(l(t(i)("setting.rateApp")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  n(j, { onClick: Q }, {
                                    default: s(() => [
                                      k(l(t(i)("setting.submitFeedback")), 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"]),
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[3] || (a[3] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "about",
                            header: t(i)("setting.aboutApp")
                          }, {
                            default: s(() => [
                              e("div", Ts, [
                                e("label", Ds, l(t(i)("setting.version")), 1),
                                e("span", Es, l(P.appInfo.version), 1)
                              ]),
                              e("div", Us, [
                                e("label", Ps, l(t(i)("setting.officialWebsite")), 1),
                                e("a", {
                                  href: _.appInfo.officialWebsite,
                                  target: "_blank",
                                  class: "contact-info"
                                }, l(_.appInfo.officialWebsite), 9, Ls)
                              ]),
                              e("div", Is, [
                                e("label", Rs, l(t(i)("setting.openSourceCommunity")), 1),
                                e("a", {
                                  href: _.appInfo.openSourceCommunity,
                                  target: "_blank",
                                  class: "contact-info"
                                }, l(_.appInfo.openSourceCommunity), 9, Bs)
                              ]),
                              e("div", Ms, [
                                e("label", zs, l(t(i)("setting.githubRepository")), 1),
                                e("a", {
                                  href: _.appInfo.githubRepository,
                                  target: "_blank",
                                  class: "contact-info"
                                }, l(_.appInfo.githubRepository), 9, As)
                              ])
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"])
                    ]),
                    _: 3
                  })
                ])
              ]),
              _: 3
            }, 8, ["tab"])),
            (c(), S(G, {
              key: "interface",
              tab: t(i)("setting.interface")
            }, {
              default: s(() => [
                e("div", qs, [
                  n(Z, {
                    direction: "vertical",
                    size: 16,
                    style: { width: "100%" }
                  }, {
                    default: s(() => [
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[5] || (a[5] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "system",
                            header: t(i)("setting.systemSettings")
                          }, {
                            default: s(() => [
                              e("div", Os, [
                                e("label", Ns, l(t(i)("setting.setAsBrowserTab")), 1),
                                n(W, {
                                  checked: r.value.isBrowserTab,
                                  onChange: a[4] || (a[4] = (o) => X("isBrowserTab", o))
                                }, null, 8, ["checked"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"]),
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[8] || (a[8] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "language",
                            header: t(i)("setting.language")
                          }, {
                            default: s(() => [
                              e("div", Fs, [
                                e("label", Qs, l(t(i)("setting.enableLanguageSetting")), 1),
                                n(W, {
                                  checked: r.value.enableLanguageSetting,
                                  onChange: a[6] || (a[6] = (o) => X("enableLanguageSetting", o))
                                }, null, 8, ["checked"])
                              ]),
                              r.value.enableLanguageSetting ? (c(), g("div", Ws, [
                                e("label", Hs, l(t(i)("setting.language")), 1),
                                n(Ie, {
                                  value: f.value,
                                  "onUpdate:value": a[7] || (a[7] = (o) => f.value = o),
                                  style: { width: "160px" },
                                  placeholder: t(i)("setting.language")
                                }, {
                                  default: s(() => [
                                    (c(!0), g(O, null, N(_.supportedLanguages, (o) => (c(), S(le, {
                                      key: o.code,
                                      value: o.code
                                    }, {
                                      default: s(() => [
                                        k(l(o.nativeName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value", "placeholder"])
                              ])) : F("", !0)
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"]),
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[11] || (a[11] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "theme",
                            header: t(i)("setting.theme")
                          }, {
                            default: s(() => [
                              e("div", Vs, [
                                e("label", Gs, l(t(i)("setting.enableThemeSetting")), 1),
                                n(W, {
                                  checked: t(be).enableThemeSetting,
                                  onChange: a[9] || (a[9] = (o) => X("enableThemeSetting", o))
                                }, null, 8, ["checked"])
                              ]),
                              t(be).enableThemeSetting ? (c(), g("div", js, [
                                e("label", Ys, l(t(i)("setting.theme")), 1),
                                n(xe, {
                                  value: p.value,
                                  "onUpdate:value": a[10] || (a[10] = (o) => p.value = o),
                                  "button-style": "solid"
                                }, {
                                  default: s(() => [
                                    n(ve, { value: "light" }, {
                                      default: s(() => [
                                        k(l(t(i)("setting.light")), 1)
                                      ]),
                                      _: 1
                                    }),
                                    n(ve, { value: "dark" }, {
                                      default: s(() => [
                                        k(l(t(i)("setting.dark")), 1)
                                      ]),
                                      _: 1
                                    }),
                                    n(ve, { value: "auto" }, {
                                      default: s(() => [
                                        k(l(t(i)("setting.auto")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ])) : F("", !0)
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"]),
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[13] || (a[13] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "ui",
                            header: t(i)("setting.uiSettings")
                          }, {
                            default: s(() => [
                              e("div", Js, [
                                e("label", Xs, l(t(i)("setting.settingOpenMode")), 1),
                                n(xe, {
                                  value: r.value.openMode,
                                  "button-style": "solid",
                                  onChange: a[12] || (a[12] = (o) => X("openMode", o))
                                }, {
                                  default: s(() => [
                                    n(ve, { value: "drawer" }, {
                                      default: s(() => [
                                        k(l(t(i)("setting.drawer")), 1)
                                      ]),
                                      _: 1
                                    }),
                                    n(ve, { value: "modal" }, {
                                      default: s(() => [
                                        k(l(t(i)("setting.modal")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["tab"])),
            (c(), S(G, {
              key: "search",
              tab: t(i)("setting.search")
            }, {
              default: s(() => [
                e("div", Zs, [
                  n(Z, {
                    direction: "vertical",
                    size: 16,
                    style: { width: "100%" }
                  }, {
                    default: s(() => [
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[16] || (a[16] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "search",
                            header: t(i)("setting.searchSettings")
                          }, {
                            default: s(() => [
                              e("div", en, [
                                e("label", tn, l(t(i)("setting.enableSmartSearch")), 1),
                                n(W, {
                                  checked: r.value.smartSearchEnabled !== !1,
                                  onChange: Ye
                                }, null, 8, ["checked"])
                              ]),
                              e("div", an, [
                                e("label", sn, l(t(i)("setting.searchHistory")), 1),
                                n(W, {
                                  checked: r.value.searchHistoryEnabled,
                                  onChange: a[14] || (a[14] = (o) => X("searchHistoryEnabled", o))
                                }, null, 8, ["checked"])
                              ]),
                              r.value.smartSearchEnabled === !1 ? (c(), g("div", nn, [
                                e("label", on, l(t(i)("setting.showSearchEngineSelector")), 1),
                                n(W, {
                                  checked: r.value.showSearchEngineSelector,
                                  onChange: a[15] || (a[15] = (o) => X("showSearchEngineSelector", o))
                                }, null, 8, ["checked"])
                              ])) : F("", !0)
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"]),
                      r.value.aiModeSearch !== !1 ? (c(), S(E, {
                        key: 0,
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[19] || (a[19] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "searchBox",
                            header: t(i)("setting.searchBoxSettings")
                          }, {
                            default: s(() => [
                              e("div", ln, [
                                e("label", cn, l(t(i)("setting.enableSearchTypeToggle")), 1),
                                n(W, {
                                  checked: r.value.enableSearchTypeToggle,
                                  onChange: a[17] || (a[17] = (o) => X("enableSearchTypeToggle", o))
                                }, null, 8, ["checked"])
                              ]),
                              r.value.enableSearchTypeToggle ? (c(), g("div", rn, [
                                e("label", dn, l(t(i)("setting.defaultSearchType")), 1),
                                n(xe, {
                                  value: r.value.defaultSearchType,
                                  "button-style": "solid",
                                  onChange: a[18] || (a[18] = (o) => X("defaultSearchType", o))
                                }, {
                                  default: s(() => [
                                    n(ve, { value: "search" }, {
                                      default: s(() => [
                                        k(l(t(i)("setting.searchBox")), 1)
                                      ]),
                                      _: 1
                                    }),
                                    n(ve, { value: "chatbot" }, {
                                      default: s(() => [
                                        k(l(t(i)("setting.chatbot")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ])) : F("", !0)
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"])) : F("", !0),
                      r.value.smartSearchEnabled ? (c(), S(E, {
                        key: 1,
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[21] || (a[21] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "searchPlatforms",
                            header: t(i)("setting.searchPlatforms")
                          }, {
                            default: s(() => [
                              e("div", un, [
                                e("label", gn, l(t(i)("setting.searchPlatformsDescription")), 1)
                              ]),
                              (c(!0), g(O, null, N(ee.value, (o) => (c(), g("div", {
                                key: o.type,
                                class: "setting-item platform-setting-item",
                                draggable: "true",
                                onDragstart: (R) => x(R, o.type),
                                onDragenter: (R) => I(R, o.type),
                                onDragend: V,
                                onDragover: a[20] || (a[20] = Me(() => {
                                }, ["prevent"])),
                                onDrop: (R) => Qe(R, o.type)
                              }, [
                                e("div", vn, [
                                  e("div", mn, [
                                    a[42] || (a[42] = e("span", { class: "drag-icon" }, "☰", -1)),
                                    k(" " + l($e(o.type)), 1)
                                  ]),
                                  e("div", pn, [
                                    n(Re, null, {
                                      default: s(() => [
                                        n(j, {
                                          size: "small",
                                          disabled: o.order === 1,
                                          onClick: (R) => we(o.type, "up")
                                        }, {
                                          default: s(() => [...a[43] || (a[43] = [
                                            k(" ↑ ", -1)
                                          ])]),
                                          _: 1
                                        }, 8, ["disabled", "onClick"]),
                                        n(j, {
                                          size: "small",
                                          disabled: o.order === ee.value.length,
                                          onClick: (R) => we(o.type, "down")
                                        }, {
                                          default: s(() => [...a[44] || (a[44] = [
                                            k(" ↓ ", -1)
                                          ])]),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    n(W, {
                                      checked: o.enabled,
                                      "onUpdate:checked": (R) => o.enabled = R,
                                      onChange: (R) => m(o.type, R)
                                    }, null, 8, ["checked", "onUpdate:checked", "onChange"])
                                  ])
                                ])
                              ], 40, hn))), 128))
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"])) : F("", !0),
                      r.value.smartSearchEnabled ? (c(), S(E, {
                        key: 2,
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[23] || (a[23] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "tags",
                            header: t(i)("setting.tags")
                          }, {
                            default: s(() => [
                              e("div", fn, [
                                e("label", _n, l(t(i)("setting.tagsDescription")), 1)
                              ]),
                              (c(!0), g(O, null, N(de.value, (o) => (c(), g("div", {
                                key: o.key,
                                class: "setting-item platform-setting-item",
                                draggable: "true",
                                onDragstart: (R) => He(R, o.key),
                                onDragenter: (R) => Ve(R, o.key),
                                onDragend: Ge,
                                onDragover: a[22] || (a[22] = Me(() => {
                                }, ["prevent"])),
                                onDrop: (R) => je(R, o.key)
                              }, [
                                e("div", bn, [
                                  e("div", kn, [
                                    a[45] || (a[45] = e("span", { class: "drag-icon" }, "☰", -1)),
                                    k(" " + l(Ke(o.key)), 1)
                                  ]),
                                  e("div", Sn, [
                                    n(Re, null, {
                                      default: s(() => [
                                        n(j, {
                                          size: "small",
                                          disabled: o.order === 1,
                                          onClick: (R) => Le(o.key, "up")
                                        }, {
                                          default: s(() => [...a[46] || (a[46] = [
                                            k(" ↑ ", -1)
                                          ])]),
                                          _: 1
                                        }, 8, ["disabled", "onClick"]),
                                        n(j, {
                                          size: "small",
                                          disabled: o.order === de.value.length,
                                          onClick: (R) => Le(o.key, "down")
                                        }, {
                                          default: s(() => [...a[47] || (a[47] = [
                                            k(" ↓ ", -1)
                                          ])]),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    n(W, {
                                      checked: o.enabled,
                                      "onUpdate:checked": (R) => o.enabled = R,
                                      onChange: (R) => We(o.key, R)
                                    }, null, 8, ["checked", "onUpdate:checked", "onChange"])
                                  ])
                                ])
                              ], 40, yn))), 128))
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"])) : F("", !0)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["tab"])),
            (c(), S(G, {
              key: "data",
              tab: t(i)("setting.data")
            }, {
              default: s(() => [
                e("div", wn, [
                  n(Z, {
                    direction: "vertical",
                    size: 16,
                    style: { width: "100%" }
                  }, {
                    default: s(() => [
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[25] || (a[25] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "data",
                            header: t(i)("setting.dataSettings")
                          }, {
                            default: s(() => [
                              e("div", Cn, [
                                e("label", $n, l(t(i)("setting.dataStorageLocation")), 1),
                                n(Ie, {
                                  value: r.value.dataStorage,
                                  style: { width: "160px" },
                                  placeholder: t(i)("setting.dataStorageLocation"),
                                  onChange: a[24] || (a[24] = (o) => X("dataStorage", o))
                                }, {
                                  default: s(() => [
                                    n(le, { value: "local" }, {
                                      default: s(() => [
                                        k(l(t(i)("setting.localStorage")), 1)
                                      ]),
                                      _: 1
                                    }),
                                    n(le, { value: "cloud" }, {
                                      default: s(() => [
                                        k(l(t(i)("setting.cloudStorage")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value", "placeholder"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"]),
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[27] || (a[27] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "backup",
                            header: t(i)("setting.myBackup")
                          }, {
                            default: s(() => [
                              e("div", Kn, [
                                e("label", xn, l(t(i)("setting.autoBackup")), 1),
                                n(W, {
                                  checked: L.value,
                                  "onUpdate:checked": a[26] || (a[26] = (o) => L.value = o)
                                }, null, 8, ["checked"])
                              ]),
                              e("div", Tn, [
                                e("div", Dn, [
                                  n(j, {
                                    type: "primary",
                                    onClick: y
                                  }, {
                                    default: s(() => [
                                      k(l(t(i)("setting.backupNow")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  n(j, { onClick: K }, {
                                    default: s(() => [
                                      k(l(t(i)("setting.restoreBackup")), 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"]),
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[28] || (a[28] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "dataManagement",
                            header: t(i)("setting.dataManagement")
                          }, {
                            default: s(() => [
                              e("div", En, [
                                e("label", Un, l(t(i)("setting.tagManagement")), 1),
                                n(j, {
                                  type: "primary",
                                  onClick: ge
                                }, {
                                  default: s(() => [
                                    k(l(t(i)("setting.manageTags")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              e("div", Pn, [
                                e("label", Ln, l(t(i)("setting.searchPlatformCategoryManagement")), 1),
                                n(j, {
                                  type: "primary",
                                  onClick: he
                                }, {
                                  default: s(() => [
                                    k(l(t(i)("setting.manageCategories")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              e("div", In, [
                                e("label", Rn, l(t(i)("setting.searchPlatformManagement")), 1),
                                n(j, {
                                  type: "primary",
                                  onClick: re
                                }, {
                                  default: s(() => [
                                    k(l(t(i)("setting.managePlatforms")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["tab"])),
            (c(), S(G, {
              key: "interaction",
              tab: t(i)("setting.notification")
            }, {
              default: s(() => [
                e("div", Bn, [
                  n(Z, {
                    direction: "vertical",
                    size: 16,
                    style: { width: "100%" }
                  }, {
                    default: s(() => [
                      n(E, {
                        activeKey: r.value.activeCollapseKeys,
                        "onUpdate:activeKey": a[31] || (a[31] = (o) => r.value.activeCollapseKeys = o),
                        class: "setting-collapse"
                      }, {
                        default: s(() => [
                          (c(), S(T, {
                            key: "interaction",
                            header: t(i)("setting.interactionSettings")
                          }, {
                            default: s(() => [
                              e("div", Mn, [
                                e("label", zn, l(t(i)("setting.enableNotifications")), 1),
                                n(W, {
                                  checked: r.value.notificationEnabled,
                                  onChange: a[29] || (a[29] = (o) => X("notificationEnabled", o))
                                }, null, 8, ["checked"])
                              ]),
                              e("div", An, [
                                e("label", qn, l(t(i)("setting.soundAlerts")), 1),
                                n(W, {
                                  checked: r.value.soundEnabled,
                                  onChange: a[30] || (a[30] = (o) => X("soundEnabled", o))
                                }, null, 8, ["checked"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["header"]))
                        ]),
                        _: 1
                      }, 8, ["activeKey"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["tab"]))
          ]),
          _: 3
        }, 8, ["activeKey"]),
        n(Te, {
          open: M.value,
          "onUpdate:open": a[33] || (a[33] = (o) => M.value = o),
          title: "标签管理",
          width: 800,
          onOk: a[34] || (a[34] = (o) => M.value = !1),
          onCancel: a[35] || (a[35] = (o) => M.value = !1)
        }, {
          default: s(() => [...a[48] || (a[48] = [
            e("div", { style: { "min-height": "400px" } }, [
              e("p", null, "标签管理功能开发中...")
            ], -1)
          ])]),
          _: 1
        }, 8, ["open"]),
        n(Te, {
          open: ae.value,
          "onUpdate:open": a[36] || (a[36] = (o) => ae.value = o),
          title: "搜索平台分类管理",
          width: 800,
          onOk: a[37] || (a[37] = (o) => ae.value = !1),
          onCancel: a[38] || (a[38] = (o) => ae.value = !1)
        }, {
          default: s(() => [...a[49] || (a[49] = [
            e("div", { style: { "min-height": "400px" } }, [
              e("p", null, "搜索平台分类管理功能开发中...")
            ], -1)
          ])]),
          _: 1
        }, 8, ["open"]),
        n(Te, {
          open: oe.value,
          "onUpdate:open": a[39] || (a[39] = (o) => oe.value = o),
          title: "搜索平台管理",
          width: 800,
          onOk: a[40] || (a[40] = (o) => oe.value = !1),
          onCancel: a[41] || (a[41] = (o) => oe.value = !1)
        }, {
          default: s(() => [...a[50] || (a[50] = [
            e("div", { style: { "min-height": "400px" } }, [
              e("p", null, "搜索平台管理功能开发中...")
            ], -1)
          ])]),
          _: 1
        }, 8, ["open"])
      ]);
    };
  }
}), fo = /* @__PURE__ */ Se(On, [["__scopeId", "data-v-3445f4c5"]]), Nn = { class: "home-container" }, Fn = {
  key: 0,
  class: "language-button-wrapper"
}, Qn = { class: "setting-button-wrapper" }, Wn = { class: "search-container" }, Hn = { class: "search-form" }, Vn = { class: "search-header-section" }, Gn = { class: "search-header-icon" }, jn = ["src", "alt"], Yn = { class: "search-header-title" }, Jn = { class: "search-title" }, Xn = {
  key: 0,
  class: "search-description"
}, Zn = {
  key: 0,
  class: "search-mode-content"
}, eo = {
  key: 1,
  class: "chatbot-mode-content"
}, to = { class: "footer-content" }, ao = ["innerHTML"], so = { key: 1 }, no = /* @__PURE__ */ ke({
  __name: "SearchHome",
  props: {
    appName: {},
    logoUrl: {},
    settingData: {},
    showSearchBox: { type: Boolean, default: !0 },
    showChatBotToggle: { type: Boolean, default: !1 },
    officialWebsite: { default: "" }
  },
  emits: ["language-change", "open-setting", "toggle-theme", "toggle-search-mode"],
  setup(P, { emit: ne }) {
    const _ = P, z = ne, $ = Oe(), { t: A } = tt(), u = Y(Ce($.value)), B = Y($.value);
    se($, (v) => {
      u.value = Ce(v), B.value = v;
    }, { immediate: !0 }), se(() => (_.settingData && _.settingData.value ? _.settingData.value : _.settingData).language, (v) => {
      if (v) {
        const M = {
          "zh-CN": "zh",
          "en-US": "en"
        }[v] || v;
        u.value = Ce(M), B.value = M, $.value !== M && ($.value = M);
      }
    }, { immediate: !0 });
    const h = (v) => {
      u.value = Ce(v), B.value = v;
    };
    h($.value);
    const r = (v) => {
      h(v), $.value !== v && ($.value = v), z("language-change", v);
    }, H = J(() => {
      const v = `<a href="${_.officialWebsite}" target="_blank" rel="noopener noreferrer">${_.appName}</a>`;
      return A("home.copyright", { name: v });
    }), w = J(() => (_.settingData && _.settingData.value ? _.settingData.value : _.settingData).theme === "dark");
    return (v, b) => {
      const M = C("a-button"), ae = C("a-menu-item"), oe = C("a-menu"), ge = C("a-dropdown"), he = C("a-layout-header"), re = C("a-card"), L = C("a-layout-content"), p = C("a-layout-footer"), f = C("a-layout");
      return c(), g("div", Nn, [
        n(f, { class: "home-layout" }, {
          default: s(() => [
            n(he, { class: "hero-header" }, {
              default: s(() => [
                b[5] || (b[5] = e("div", { class: "hero-content" }, null, -1)),
                (P.settingData && P.settingData.value ? P.settingData.value.enableLanguageSetting : P.settingData.enableLanguageSetting) !== !1 ? (c(), g("div", Fn, [
                  n(ge, {
                    trigger: "click",
                    class: "language-dropdown"
                  }, {
                    overlay: s(() => [
                      n(oe, { class: "language-menu" }, {
                        default: s(() => [
                          (c(!0), g(O, null, N(t(at), (y) => (c(), S(ae, {
                            key: y.code,
                            class: "language-menu-item",
                            onClick: (K) => r(y.code)
                          }, {
                            default: s(() => [
                              k(l(y.nativeName), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    default: s(() => [
                      n(M, {
                        type: "text",
                        class: "language-button"
                      }, {
                        default: s(() => [
                          b[3] || (b[3] = e("span", { class: "language-icon" }, "🌎", -1)),
                          k(" " + l(u.value) + " ", 1),
                          b[4] || (b[4] = e("span", { class: "anticon anticon-down" }, [
                            e("svg", {
                              viewBox: "64 64 896 896",
                              focusable: "false",
                              "data-icon": "down",
                              width: "1em",
                              height: "1em",
                              fill: "currentColor",
                              "aria-hidden": "true"
                            }, [
                              e("path", { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" })
                            ])
                          ], -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])) : F("", !0),
                e("div", Qn, [
                  n(M, {
                    type: "text",
                    class: "setting-button",
                    onClick: b[0] || (b[0] = (y) => v.$emit("open-setting"))
                  }, {
                    default: s(() => [
                      k(" ⚙️ " + l(t(A)("common.setting")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            n(L, { class: "search-content" }, {
              default: s(() => [
                e("div", Wn, [
                  n(re, {
                    class: "search-card",
                    bordered: !1
                  }, {
                    default: s(() => [
                      n(M, {
                        type: "text",
                        size: "small",
                        class: "theme-toggle-button",
                        onClick: b[1] || (b[1] = (y) => v.$emit("toggle-theme"))
                      }, {
                        default: s(() => [
                          k(l(w.value ? "🌞 " + t(A)("home.lightMode") : "🌙 " + t(A)("home.darkMode")), 1)
                        ]),
                        _: 1
                      }),
                      P.showChatBotToggle ? (c(), S(M, {
                        key: 0,
                        type: "text",
                        size: "small",
                        class: "toggle-search-mode-button",
                        onClick: b[2] || (b[2] = (y) => v.$emit("toggle-search-mode"))
                      }, {
                        default: s(() => [
                          k(l(P.showSearchBox ? "🤖 " + t(A)("home.switchToChatBot") : "🔍 " + t(A)("home.switchToSearchBox")), 1)
                        ]),
                        _: 1
                      })) : F("", !0),
                      e("div", Hn, [
                        e("div", Vn, [
                          e("span", Gn, [
                            e("img", {
                              src: P.logoUrl,
                              alt: P.appName + " Logo",
                              style: { width: "64px", height: "64px" }
                            }, null, 8, jn)
                          ]),
                          e("h1", Yn, l(P.appName), 1)
                        ]),
                        e("h2", Jn, l(t(A)("home.intelligentSearch")), 1),
                        P.settingData.smartSearchEnabled !== !1 ? (c(), g("p", Xn, l(t(A)("home.searchDescription")), 1)) : F("", !0),
                        pe(v.$slots, "search-content", {}, () => [
                          P.showSearchBox ? (c(), g("div", Zn, [
                            pe(v.$slots, "search-box", {}, void 0, !0)
                          ])) : (c(), g("div", eo, [
                            pe(v.$slots, "chatbot", {}, void 0, !0)
                          ]))
                        ], !0)
                      ])
                    ]),
                    _: 3
                  }),
                  pe(v.$slots, "smart-search", {}, () => [
                    P.settingData.smartSearchEnabled !== !1 ? (c(), S(t(pa), {
                      key: 0,
                      settingData: P.settingData
                    }, null, 8, ["settingData"])) : F("", !0)
                  ], !0)
                ])
              ]),
              _: 3
            }),
            n(p, { class: "home-footer" }, {
              default: s(() => [
                e("div", to, [
                  P.officialWebsite ? (c(), g("p", {
                    key: 0,
                    innerHTML: H.value
                  }, null, 8, ao)) : (c(), g("p", so, l(t(A)("home.copyright", { name: P.appName })), 1))
                ])
              ]),
              _: 1
            })
          ]),
          _: 3
        })
      ]);
    };
  }
}), _o = /* @__PURE__ */ Se(no, [["__scopeId", "data-v-81445cda"]]);
export {
  mo as SearchBox,
  _o as SearchHome,
  po as SearchResults,
  fo as SearchSetting,
  pa as SmartSearch
};
//# sourceMappingURL=index.mjs.map
